<template>
	<div>
		<div v-if="!visualizar" class="container-fluid no-print">
			<!-- cabecalho -->
			<div v-if="cabecalho" class="fl-cabecalho">
				<div class="row">
					<div class="col-lg-4 col-xs-12">
						<i class="icon icon-diario_bordo"></i>
						<h3>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h3>
						<h4>{{ _traducao('global', 'pilotoECopiloto').toUpperCase() }}</h4>
					</div>

					<div class="col-xs-12 col-lg-4">
						<span v-if="form.id == 0">
							<i class="icon icon-solicitacao_nova_solicitacao icon-sub"></i>
							<h3>{{ _traducao('global', 'preencher').toUpperCase() }}</h3>
						</span>

						<span v-if="form.id != 0">
							<i class="icon icon-editar icon-sub"></i>
							<h3>{{ _traducao('global', 'editar').toUpperCase() }}</h3>
						</span>

						<h4>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h4>
					</div>

					<div class="col-xs-12 col-lg-4">
						<button @click="voltaLista()" class="btn btn-default pull-right btn-lg" :title="_traducao('global', 'voltar')">
							<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
						</button>

						<button
							class="btn btn-default pull-right btn-lg"
							:title="_traducao('global', 'imprimir')"
							style="margin-right: 20px"
							@click="clickPrint()"
						>
							<i class="icon-imprimir" style="font-size: 18px"></i>
						</button>
					</div>
				</div>
			</div>

			<!-- FORM -->
			<div>
				<!-- AERONAVE -->
				<div>
					<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'aeronave')" />

					<div class="row">
						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('cadAeronave', 'prefixo') }}:</label>
							<br />
							<p>{{ aeronave.prefixo }}</p>
						</div>
						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('cadAeronave', 'codinome') }}:</label>
							<br />
							<p>{{ aeronave.codinome }}</p>
						</div>
						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('global', 'categoria') }}:</label>
							<br />
							<p>{{ aeronave.categoria }}</p>
						</div>
						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('global', 'tipo') }}:</label>
							<br />
							<p v-if="aeronave.tipo == 'H'">{{ _traducao('cadAeronave', 'helicoptero').toUpperCase() }}</p>
							<p v-if="aeronave.tipo == 'A'">{{ _traducao('cadAeronave', 'aviao').toUpperCase() }}</p>
						</div>
						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('global', 'fabricante') }}:</label>
							<br />
							<p>{{ aeronave.fabricante }}</p>
						</div>
						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('cadAeronave', 'modelo') }}:</label>
							<br />
							<p>{{ aeronave.modelo }}</p>
						</div>
						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('cadAeronave', 'serialNumber') }}:</label>
							<br />
							<p>{{ aeronave.serial_number == null || aeronave.serial_number == '' ? 'N/A' : aeronave.serial_number }}</p>
						</div>
						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('global', 'numero') }}:</label>
							<br />
							<p>{{ trecho.numero_diario == null ? 'GERADO APÓS O PREENCHIMENTO' : trecho.numero_diario }}</p>
						</div>

						<div class="col-xs-6 col-md-2">
							<label>{{ _traducao('global', 'data') }}:</label>
							<br />
							<p>
								{{ trecho.acionamento == '' || trecho.acionamento == null ? 'N/A' : trecho.acionamento.split(' ')[0] | data }}
							</p>
						</div>
					</div>

					<flCabecalhoForm cls="print-titulo-form" :texto="_traducao('global', 'manutencao')" />

					<div class="row">
						<div class="col-md-2 col-xs-6">
							<label>Tipo da última intervenção:</label>
							<br />
							<p style="margin-bottom: 0px">
								{{ form.descricao_ultima_inspecao }} <small>({{ form.ultima_intervencao | data }})</small>
							</p>
						</div>
						<div class="col-md-2 col-xs-6">
							<label>Tipo da próxima intervenção:</label>
							<br />
							<p style="margin-bottom: 0px">
								{{ form.descricao_proxima_inspecao }} <small>({{ form.proxima_intervencao | data }})</small>
							</p>
						</div>
						<div class="col-md-4 col-xs-12">
							<label>{{ _traducao('global', 'horasDeCelulaParaAProxima') }}:</label>
							<br />
							<p v-if="form.horimetro_proxima == null">N/A</p>
							<p v-else>
								{{ form.horimetro_proxima | horimetro }}
							</p>
						</div>
						<div class="col-md-4 col-xs-12">
							<label>{{ _traducao('global', 'responsavelPelaAprovacao') }}:</label>
							<br />
							<p>{{ form.nome_usuario_retorno | na }}</p>
						</div>
					</div>

					<!-- <pre>{{aeronave}}</pre> -->

					<flCabecalhoForm v-if="editar" cls="print-titulo-form" :texto="'Ciclos Totais'" />

					<div class="row" v-if="editar">
						<div class="col-md-1 col-xs-6">
							<label>Hor. Inicial Célula</label>
							<br />
							<p style="margin-bottom: 0px">{{ form.horimetro_inicial | horimetro }}</p>
						</div>
						<div class="col-md-1 col-xs-6">
							<label>Hor. Final Célula</label>
							<br />
							<p style="margin-bottom: 0px">{{ form.horimetro_final | horimetro }}</p>
						</div>
						<div class="col-md-1 text-center col-xs-6">
							<label>Total de Partidas</label>
							<br />
							<p style="margin-bottom: 0px">{{ Number(form.total_partidas) + Number(form.partidas) }}</p>
						</div>
						<div class="col-md-1 text-center col-xs-6">
							<label>Total de Pousos</label>
							<br />
							<p style="margin-bottom: 0px">{{ Number(form.total_pousos) + Number(form.pousos) }}</p>
						</div>
						<div class="col-md-1 text-center col-xs-6" v-if="aeronave.tipo == 'H'">
							<label>Total de Gancho</label>
							<br />
							<p style="margin-bottom: 0px">{{ Number(form.total_gancho) + Number(form.gancho) }}</p>
						</div>
						<div class="col-md-1 text-center col-xs-6" v-if="aeronave.tipo == 'H'">
							<label>Total de Guincho</label>
							<br />
							<p style="margin-bottom: 0px">{{ Number(form.total_guincho) + Number(form.guincho) }}</p>
						</div>
						<div class="col-md-1 text-center col-xs-6">
							<label>Total de Ciclos NG</label>
							<br />
							<div v-for="mt in form.motores" :key="'f' + mt.id">
								<div>{{ (Number(mt.ciclo_ng) + Number(form.ciclo_ng)) | horimetro2 }}</div>
							</div>
							<div v-if="form.motores.length == 0">N/A</div>
							<!-- <small>({{form.ciclo_nf | horimetro2}})</small> -->
						</div>
						<div class="col-md-1 text-center col-xs-6">
							<label>Total de Ciclos NF</label>
							<br />
							<div v-for="mt in form.motores" :key="'f' + mt.id">
								<div>{{ (Number(mt.ciclo_nf) + Number(form.ciclo_nf)) | horimetro2 }}</div>
							</div>
							<div v-if="form.motores.length == 0">N/A</div>
						</div>
					</div>
				</div>

				<!-- ORIGEM DO VOO -->
				<div>
					<flCabecalhoForm cls="print-titulo-form-20" :texto="'Despacho de Aeronaves'" />

					<!-- <flCabecalhoForm  cls="print-titulo-form" :texto="_traducao('global', 'voo')" /> -->

					<div class="row">
						<div class="col-xs-6">
							<button class="btn btn-info" type="button" @click="clickSetaTipoDiario()">
								<span v-if="despacho == ''"
									><i class="fa fa-fw fa-plus"></i>{{ _traducao('global', 'adicionarDespacho').toUpperCase() }}</span
								>
								<span v-if="despacho != ''"
									><i class="fa fa-fw fa-refresh"></i>{{ _traducao('global', 'alterarDespacho').toUpperCase() }}
								</span>
							</button>
						</div>
					</div>

					<!-- DESPACHO -->
					<div style="margin-top: 18px" v-if="despacho != ''">
						<div class="row">
							<div class="col-xs-6 col-md-2">
								<label>{{ _traducao('global', 'codigo') }}:</label>
								<br />
								<p>{{ despacho.numero }}</p>
							</div>

							<div class="col-xs-6 col-md-2">
								<label>{{ _traducao('global', 'data') }}:</label>
								<br />
								<p>{{ despacho.data_inicio | dataTempo }}</p>
							</div>

							<div class="col-md-4 col-xs-12">
								<label>{{ _traducao('global', 'descricao') }}:</label>
								<br />
								<p>{{ despacho.historico }}</p>
							</div>

							<div class="col-xs-12 col-md-4" :class="{'has-error': erro.finalizar_despacho != ''}">
								<label>* Deseja encerrar esse despacho?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.finalizar_despacho = '1'
											erro.finalizar_despacho = ''
										"
										:class="{'btn-info': form.finalizar_despacho == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.finalizar_despacho = '0'
											erro.finalizar_despacho = ''
										"
										:class="{'btn-info': form.finalizar_despacho == '0'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.finalizar_despacho">{{ erro.finalizar_despacho }}</p>
							</div>
						</div>

						<div v-if="despacho.id_ordem_missao != null">
							<flCabecalhoForm cls="print-titulo-form-20" :texto="'Ordem de Missão'" />

							<div class="row">
								<div class="col-xs-6 col-md-2">
									<label>{{ _traducao('global', 'codigo') }}:</label>
									<br />
									<p>{{ despacho.ordem_codigo }}</p>
								</div>

								<div class="col-xs-6 col-md-2">
									<label>{{ _traducao('global', 'data') }}:</label>
									<br />
									<p>{{ despacho.ordem_data_inicio | dataTempo }}</p>
								</div>

								<div class="col-md-4 col-xs-12">
									<label>{{ _traducao('global', 'descricao') }}:</label>
									<br />
									<p v-html="despacho.ordem_descricao"></p>
								</div>

								<div class="col-md-4 col-xs-12" :class="{'has-error': erro.finalizar_ordem != ''}">
									<label>* {{ _traducao('global', 'desejaEncerrarEssaOrdemDeMissao') }}</label>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button
											type="button"
											@click="
												form.finalizar_ordem = '1'
												erro.finalizar_ordem = ''
											"
											:disabled="edicao && form.finalizar_ordem == 1"
											:class="{'btn-info': form.finalizar_ordem == '1'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'sim') }}
										</button>
										<button
											type="button"
											@click="
												form.finalizar_ordem = '0'
												erro.finalizar_ordem = ''
											"
											:class="{'btn-info': form.finalizar_ordem == '0'}"
											:disabled="edicao && form.finalizar_ordem == 1"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'nao') }}
										</button>
									</div>
									<p class="help-block" v-if="erro.finalizar_ordem">{{ erro.finalizar_ordem }}</p>
								</div>
							</div>
						</div>

						<PRE>{{ despacho.id_prevencao_qualificada }}</PRE>

						<div v-if="despacho.id_prevencao_qualificada != null">
							<flCabecalhoForm cls="print-titulo-form-20" :texto="'Prevenção Qualificada'" />

							<div class="row">
								<div class="col-xs-6 col-md-2">
									<label>{{ _traducao('global', 'codigo') }}:</label>
									<br />
									<p>{{ despacho.prevencao_codigo }}</p>
								</div>

								<div class="col-xs-6 col-md-2">
									<label>{{ _traducao('global', 'inicio') }}:</label>
									<br />
									<p>{{ despacho.prevencao_inicio | dataTempo }}</p>
								</div>

								<div class="col-xs-6 col-md-2">
									<label>{{ _traducao('global', 'inicio') }}:</label>
									<br />
									<p>{{ despacho.prevencao_fim | dataTempo }}</p>
								</div>

								<div class="col-md-4 col-xs-12">
									<label>{{ _traducao('global', 'descricao') }}:</label>
									<br />
									<p v-html="despacho.prevencao_descricao"></p>
								</div>
								<!--
								<div class="col-md-4 col-xs-12"  :class="{'has-error' : erro.finalizar_ordem != ''}">
									<label>* {{_traducao('global','desejaEncerrarEssaOrdemDeMissao')}}</label>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button type="button" @click="form.finalizar_ordem = '1'; erro.finalizar_ordem = '';" :disabled="edicao && form.finalizar_ordem == 1"
											:class="{'btn-info': form.finalizar_ordem == '1'}" class="btn btn-default btn-sm">
											{{_traducao('global','sim')}}
										</button>
										<button type="button" @click="form.finalizar_ordem = '0'; erro.finalizar_ordem = '';" :class="{'btn-info': form.finalizar_ordem == '0'}"
											:disabled="edicao && form.finalizar_ordem == 1" class="btn btn-default btn-sm">
											{{_traducao('global','nao')}}
										</button>
									</div>
									<p class="help-block" v-if="erro.finalizar_ordem">{{erro.finalizar_ordem}}</p>
								</div> -->
							</div>
						</div>

						<div v-if="despacho.id_solicitacao != null">
							<flCabecalhoForm cls="print-titulo-form-20" :texto="'Solicitação de Uso de Aeronave'" />

							<div class="row">
								<div class="col-xs-6 col-md-2">
									<label>{{ _traducao('global', 'codigo') }}:</label>
									<br />
									<p>{{ despacho.solicitacao_codigo }}</p>
								</div>

								<div class="col-md-10 col-xs-12">
									<label>{{ _traducao('global', 'descricao') }}:</label>
									<br />
									<p>{{ despacho.solicitacao_descricao }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- EXIBE O FORM SE O TIPO DO VOO FOR DIFERENTE DE VAZIO -->
				<div v-if="exibeForm">
					<!-- MOTOR E HORÁRIO, TRECHO E HORIMETRO -->
					<div>
						<div class="row">
							<div class="col-xs-12 col-md-4">
								<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'motorEHorario')" />

								<div class="row">
									<!-- acionamento -->
									<div class="col-xs-6 form-group" :class="{'has-error': erro.acionamento != ''}">
										<label>* {{ _traducao('global', 'acionamento') }}:</label>
										<flDateTime
											@v-model="(val) => setaAcionamento(val)"
											:value="form.acionamento"
											name="dtOrdemInicio"
											:lang="_getLangDp"
											:maxDate="maxDate"
											time="HH:mm"
											:format="_formatDate"
										/>
										<p class="help-block" v-if="erro.acionamento != ''">{{ erro.acionamento }}</p>
										<label v-show="form.acionamento_utc != ''" style="position: absolute">UTC: {{ form.acionamento_utc }}</label>
									</div>

									<!-- decolagem -->
									<div class="col-xs-6 form-group" :class="{'has-error': erro.decolagem != ''}">
										<label
											><span v-show="form.tipo_voo_pagamento == 'S' || form.pouso != ''">*</span>
											{{ _traducao('global', 'decolagem') }}:</label
										>
										<flDateTime
											@v-model="(val) => setaDecolagem(val)"
											:value="form.decolagem"
											name="dtOrdemInicio"
											:lang="_getLangDp"
											:maxDate="maxDate"
											time="HH:mm"
											:format="_formatDate"
										/>
										<p class="help-block" v-if="erro.decolagem != ''">{{ erro.decolagem }}</p>
										<label v-show="form.decolagem_utc != ''" style="position: absolute">UTC: {{ form.decolagem_utc }}</label>
									</div>
								</div>

								<div class="row">
									<!-- pouso -->
									<div class="col-xs-6 form-group" style="margin-top: 16px" :class="{'has-error': erro.pouso != ''}">
										<label
											><span v-show="form.tipo_voo_pagamento == 'S' || form.decolagem != ''">*</span>
											{{ _traducao('global', 'pouso') }}:</label
										>
										<flDateTime
											@v-model="(val) => setaPouso(val)"
											:value="form.pouso"
											name="dtOrdemPouso"
											:lang="_getLangDp"
											time="HH:mm"
											:maxDate="maxDate"
											:format="_formatDate"
										/>
										<p class="help-block" v-if="erro.pouso != ''">{{ erro.pouso }}</p>
										<label v-show="form.pouso_utc != ''" style="position: absolute">UTC: {{ form.pouso_utc }}</label>
									</div>

									<!-- corte -->
									<div class="col-xs-6 form-group" style="margin-top: 16px" :class="{'has-error': erro.corte != ''}">
										<label>* {{ _traducao('global', 'corte') }}:</label>
										<flDateTime
											@v-model="(val) => setaCorte(val)"
											:value="form.corte"
											name="dtOrdemPouso"
											:lang="_getLangDp"
											time="HH:mm"
											:maxDate="maxDate"
											:format="_formatDate"
										/>
										<p class="help-block" v-if="erro.corte != ''">{{ erro.corte }}</p>
										<label v-show="form.corte_utc != ''" style="position: absolute">UTC: {{ form.corte_utc }}</label>
									</div>
								</div>
							</div>

							<div class="col-md-6 col-xs-12">
								<flCabecalhoForm cls="print-titulo-form-20" texto="Trecho" />

								<!-- DE -->
								<div class="row">
									<div class="col-xs-12 col-md-4 form-group" :class="{'has-error': erro.de != ''}">
										<label>* {{ _traducao('menuVoo', 'menuVde') }}: </label>
										<a href="#" @click.prevent="clickInverter()" style="position: absolute; right: 16px">
											<i class="fa fa-retweet fa-fw" aria-hidden="true"></i>Inverter
										</a>

										<v-select v-model="form.de_select" label="sigla" class="form-control input-sm" :options="rotaER"></v-select>
										<p class="help-block" v-if="erro.de != ''">{{ erro.de }}</p>
									</div>
									<div
										class="col-xs-12 col-md-3 form-group"
										v-if="form.de != ''"
										:class="{'has-error': erro.nome_estado_de != ''}"
									>
										<label>* {{ _traducao('global', 'estado') }}:</label>
										<select
											v-model="form.nome_estado_de"
											@change="blurCarregaCidades('de', true)"
											:disabled="form.de != 'ZZZZ'"
											class="form-control input-sm"
										>
											<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
											<option v-for="item in estados" :value="item.sigla" :key="item.sigla.toUpperCase()">
												{{ item.sigla.toUpperCase() }}
											</option>
										</select>
										<p class="help-block" v-if="erro.nome_estado_de != ''">{{ erro.nome_estado_de }}</p>
									</div>
									<div
										class="col-xs-12 col-md-5 form-group"
										v-if="form.de != ''"
										:class="{'has-error': erro.nome_cidade_de != ''}"
									>
										<label>* {{ _traducao('global', 'cidade') }}:</label>
										<span class="pull-right" v-if="loadDe">
											<i class="fa fa-fw fa-refresh fa-spin"></i> {{ _traducao('global', 'carregando') }}...</span
										>
										<input
											type="text"
											disabled="disabled"
											v-if="form.de != 'ZZZZ'"
											class="form-control input-sm"
											v-model="form.nome_cidade_de"
										/>
										<select v-model="form.nome_cidade_de" v-if="form.de == 'ZZZZ'" class="form-control input-sm">
											<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
											<option v-for="item in cidadesDe" :value="item.descricao" :key="item.descricao.toUpperCase()">
												{{ item.descricao.toUpperCase() }}
											</option>
										</select>
										<p class="help-block" v-if="erro.nome_cidade_de != ''">{{ erro.nome_cidade_de }}</p>
									</div>
								</div>

								<!-- PARA -->
								<div class="row">
									<div class="col-xs-12 col-md-4 form-group" style="margin-top: 16px" :class="{'has-error': erro.para != ''}">
										<label>* {{ _traducao('menuVoo', 'menuVpara') }}:</label>

										<a href="#" @click.prevent="clickCopiarDe()" style="position: absolute; right: 16px">
											<i class="fa fa-hand-o-up fa-fw" aria-hidden="true"></i>Copiar
										</a>
										<v-select v-model="form.para_select" label="sigla" class="form-control input-sm" :options="rotaER"></v-select>
										<p class="help-block" v-if="erro.para != ''">{{ erro.para }}</p>
									</div>
									<div
										class="col-xs-12 col-md-3 form-group"
										style="margin-top: 16px"
										v-if="form.para != ''"
										:class="{'has-error': erro.nome_estado_para != ''}"
									>
										<label>* {{ _traducao('global', 'estado') }}:</label>
										<select
											v-model="form.nome_estado_para"
											@change="blurCarregaCidades('para', true)"
											:disabled="form.para != 'ZZZZ'"
											class="form-control input-sm"
										>
											<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
											<option v-for="item in estados" :value="item.sigla" :key="item.sigla.toUpperCase()">
												{{ item.sigla.toUpperCase() }}
											</option>
										</select>
										<p class="help-block" v-if="erro.nome_estado_para != ''">{{ erro.nome_estado_para }}</p>
									</div>
									<div
										class="col-xs-12 col-md-5 form-group"
										style="margin-top: 16px"
										v-if="form.para != ''"
										:class="{'has-error': erro.nome_cidade_para != ''}"
									>
										<label>{{ _traducao('global', 'cidade') }}:</label>
										<span class="pull-right" v-if="loadPara">
											<i class="fa fa-fw fa-refresh fa-spin"></i> {{ _traducao('global', 'carregando') }}...</span
										>
										<input
											type="text"
											disabled="disabled"
											v-if="form.para != 'ZZZZ'"
											class="form-control input-sm"
											v-model="form.nome_cidade_para"
										/>
										<select v-model="form.nome_cidade_para" v-if="form.para == 'ZZZZ'" class="form-control input-sm">
											<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
											<option v-for="item in cidadesPara" :value="item.descricao" :key="item.descricao.toUpperCase()">
												{{ item.descricao.toUpperCase() }}
											</option>
										</select>
										<p class="help-block" v-if="erro.nome_cidade_para != ''">{{ erro.nome_cidade_para }}</p>
									</div>
								</div>
							</div>

							<div class="col-xs-12 col-md-2">
								<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'horimetro')" />

								<div class="row">
									<!-- horimetro inicial -->
									<div class="col-xs-12 form-group" :class="{'has-error': erro.horimetro_inicial != ''}">
										<label>{{ _traducao('global', 'inicial') }}:</label>
										<money
											type="text"
											v-model="form.horimetro_inicial"
											disabled="disabled"
											v-bind="_vpercem(1)"
											class="input-sm form-control"
										></money>
										<p class="help-block" v-if="erro.horimetro_inicial != ''">{{ erro.horimetro_inicial }}</p>
									</div>
								</div>

								<div class="row">
									<div class="col-xs-12 form-group" style="margin-top: 16px" :class="{'has-error': erro.horimetro_final != ''}">
										<label>{{ _traducao('global', 'final') }}:</label>
										<money
											type="text"
											v-model="form.horimetro_final"
											disabled="disabled"
											v-bind="_vpercem(1)"
											class="input-sm form-control"
										></money>
										<p class="help-block" v-if="erro.horimetro_final != ''">{{ erro.horimetro_final }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- TEMPO DE VOO -->
					<div>
						<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'tempoDeVoo')" />

						<div class="row">
							<!-- TEMPO VOO PILOTO -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.tempo_voo_piloto != ''}">
								<label>Total de Horas (Voo):</label>
								<money
									type="text"
									disabled="disabled"
									v-model="form.tempo_voo_piloto"
									v-bind="_vpercem(1)"
									class="input-sm form-control"
								></money>
								<p class="help-block" v-if="erro.tempo_voo_piloto != ''">{{ erro.tempo_voo_piloto }}</p>
								<label v-show="tempoVooPiloto != ''">{{ _traducao('global', 'tempo') }}: {{ tempoVooPiloto }}</label>
							</div>

							<!-- TEMPO VOO MANUTENÇÃO -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.tempo_voo_motor != ''}">
								<label>Total de Horas (Célula):</label>
								<label
									:disabled="true"
									v-show="form.adiciona_horimetro_manutencao == '1'"
									style="right: 30px; top: 19px"
									class="btn pass-btn-mais-btn btn-link"
									>+ 1</label
								>
								<money
									type="text"
									disabled="disabled"
									v-model="form.tempo_voo_motor"
									v-bind="_vpercem(1)"
									class="input-sm form-control"
								></money>
								<p class="help-block" v-if="erro.tempo_voo_motor != ''">{{ erro.tempo_voo_motor }}</p>
								<label v-show="tempoVooMotor != ''">{{ _traducao('global', 'tempo') }}: {{ tempoVooMotor }}</label>
							</div>

							<!-- VFR DIURNO -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.vfr_diurno != ''}">
								<label>{{ _traducao('global', 'diurno') }}:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_vfr_diurno = val
											validaTempoDeVoo('D')
										}
									"
									:value="form.hora_vfr_diurno"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<p class="help-block" v-if="erro.vfr_diurno != ''">{{ erro.vfr_diurno }}</p>
								<label v-show="form.vfr_diurno != ''">Décimo: {{ form.vfr_diurno }}</label>
							</div>

							<!-- VFR  NOTURNO -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.vfr_noturno != ''}">
								<label>{{ _traducao('global', 'noturno') }}:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_vfr_noturno = val
											validaTempoDeVoo('N')
										}
									"
									:value="form.hora_vfr_noturno"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<p class="help-block" v-if="erro.vfr_noturno != ''">{{ erro.vfr_noturno }}</p>
								<label v-show="form.vfr_noturno != ''">Décimo: {{ form.vfr_noturno }}</label>
							</div>

							<!-- IFR -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.ifr != ''}">
								<label>IFR:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_ifr = val
											validaTempoDeVoo('IFR')
										}
									"
									:value="form.hora_ifr"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<label v-show="form.ifr != ''">Décimo: {{ form.ifr }}</label>
								<p class="help-block" v-if="erro.ifr != ''">{{ erro.ifr }}</p>
							</div>

							<!-- NAVEGACAO -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.navegacao != ''}">
								<label>{{ _traducao('global', 'navegacao') }}:</label>
								<flDateTime
									@v-model="
										(val) => {
											form.hora_navegacao = val
											validaTempoDeVoo('NA')
										}
									"
									:value="form.hora_navegacao"
									name="dtOrdemInicio"
									:lang="_getLangDp"
									:format="'HH:mm'"
								/>
								<!-- <money type="text" v-model="form.navegacao" v-bind="_vpercem(1)" class="input-sm form-control"></money> -->
								<label v-show="form.navegacao != ''">Décimo: {{ form.navegacao }}</label>
								<p class="help-block" v-if="erro.navegacao != ''">{{ erro.navegacao }}</p>
							</div>
						</div>
					</div>

					<!-- DADOS DO VOO -->
					<div>
						<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'dadosDoVoo')" />

						<div class="row">
							<!-- COMBISTIVEL -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.combustivel != ''}">
								<label>* {{ _traducao('global', 'combustivel') }}:</label>
								<money type="text" v-model="form.combustivel" v-bind="_vpercem(0)" class="input-sm form-control"></money>
								<p class="help-block" v-if="erro.combustivel != ''">{{ erro.combustivel }}</p>
							</div>

							<!-- UNIDADE -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.unidade_combustivel != ''}">
								<label>* {{ _traducao('global', 'relacao') }}:</label>
								<select class="form-control input-sm" v-model="form.unidade_combustivel">
									<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
									<option value="%">%</option>
									<option value="Litros">Litros</option>
									<option value="Libras">Libras</option>
									<option value="Galão">Galão</option>
									<option value="Kg">Kg</option>
								</select>
								<p class="help-block" v-if="erro.unidade_combustivel != ''">{{ erro.unidade_combustivel }}</p>
							</div>

							<!-- PARTIDAS -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.partidas != ''}">
								<label>{{ _traducao('global', 'partidas') }}:</label>
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.partidas += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									class="pass-btn-menos-btn btn-link text-center"
									:disabled="form.partidas == 1"
									@click.prevent="form.partidas -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.partidas"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
								<p class="help-block" v-if="erro.partidas != ''">{{ erro.partidas }}</p>
							</div>

							<!-- POUSOS -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.pousos != ''}">
								<label>{{ _traducao('global', 'pousos') }}:</label>
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.pousos += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pousos == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pousos -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pousos"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
								<p class="help-block" v-if="erro.pousos != ''">{{ erro.pousos }}</p>
							</div>

							<!-- GUINCHO -->
							<div class="col-xs-6 col-md-2 form-group" v-if="aeronave.tipo == 'H'">
								<label>{{ _traducao('global', 'guincho') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.guincho += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.guincho == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.guincho -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.guincho"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- GANCHO -->
							<div class="col-xs-6 col-md-2 form-group" v-if="aeronave.tipo == 'H'">
								<label>{{ _traducao('global', 'gancho') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.gancho += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.gancho == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.gancho -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.gancho"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<div class="row">
							<!-- PAX  -->
							<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.pax != ''}">
								<label>PAX:</label>
								<input type="text" disabled="disabled" :value="form.passageiro.length" class="form-control input-sm" />
								<p class="help-block" v-if="erro.pax != ''">{{ erro.pax }}</p>
							</div>
							<!-- POB -->
							<div class="col-xs-6 col-md-2 form-group">
								<label>POB:</label>
								<input
									type="text"
									disabled="disabled"
									:value="form.passageiro.length + form.tripulacao.length"
									class="form-control input-sm"
								/>
							</div>

							<!-- flir -->
							<!-- <div class="col-xs-6 col-md-2 form-group" v-if="aeronave.tipo == 'H'" :class="{'has-error' : erro.flir != ''}">
                                <label>* {{_traducao('global', 'usoDe')}} FLIR:</label>
                                <br />
                                <div class="btn-group  print-button-group" role="group">
                                    <button type="button" @click="form.flir = '1'; erro.flir = '';" :class="{'btn-info': form.flir == '1'}" class="btn btn-default btn-sm">
                                        {{_traducao('global','sim')}}
                                    </button>
                                    <button type="button" @click="form.flir = '0'; erro.flir = '';" :class="{'btn-info': form.flir == '0'}" class="btn btn-default btn-sm">
                                        {{_traducao('global','nao')}}
                                    </button>
                                </div>
                                <p class="help-block" v-if="erro.flir != ''">{{erro.flir}}</p>
                            </div> -->
							<!-- OVN -->
							<!-- <div class="col-xs-6 col-md-2  form-group" v-if="aeronave.tipo == 'H'" :class="{'has-error' : erro.ovn != ''}">
                                <label>* {{_traducao('global', 'usoDe')}} OVN:</label>
                                <br/>
                                <div class="btn-group print-button-group" role="group">
                                    <button type="button" @click="form.ovn = '1'; erro.ovn = '';" :class="{'btn-info': form.ovn == '1'}" class="btn btn-default btn-sm">
                                        {{_traducao('global','sim')}}
                                    </button>
                                    <button type="button" @click="form.ovn = '0'; erro.ovn = '';" :class="{'btn-info': form.ovn == '0'}" class="btn btn-default btn-sm">
                                        {{_traducao('global','nao')}}
                                    </button>
                                </div>
                                <p class="help-block" v-if="erro.ovn != ''">{{erro.ovn}}</p>
                            </div> -->
						</div>
						<div class="row" v-if="aeronave.ciclo_total == '1'">
							<div>
								<!-- CICLO NG -->
								<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.ciclo_ng != ''}">
									<label>{{ _traducao('conversao', 'ciclo') }} NG:</label>
									<money type="text" v-model="form.ciclo_ng" class="form-control input-sm" v-bind="_vpercem(2)"></money>
									<p class="help-block" v-if="erro.ciclo_ng != ''">{{ erro.ciclo_ng }}</p>
								</div>
								<!-- CICLO NF -->
								<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.ciclo_ng != ''}">
									<label>{{ _traducao('conversao', 'ciclo') }} NF:</label>
									<money type="text" v-model="form.ciclo_nf" class="form-control input-sm" v-bind="_vpercem(2)"></money>
									<p class="help-block" v-if="erro.ciclo_nf != ''">{{ erro.ciclo_nf }}</p>
								</div>

								<!-- NUMERO DO VOO -->
								<div class="col-xs-6 col-md-2 form-group" :class="{'has-error': erro.numero_voo != ''}">
									<label>* {{ _traducao('global', 'numeroDeVoo') }}:</label>
									<input type="number" v-model="form.numero_voo" class="form-control input-sm" />
									<p class="help-block" v-if="erro.numero_voo != ''">{{ erro.numero_voo }}</p>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.tipo_voo_pagamento != ''}">
								<label>* Qual o tipo do voo?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.tipo_voo_pagamento = 'E'
											erro.tipo_voo_pagamento = ''
											form.adiciona_horimetro_manutencao = ''
										"
										:class="{'btn-info': form.tipo_voo_pagamento == 'E'}"
										class="btn btn-default btn-sm"
									>
										Experiência
									</button>
									<button
										type="button"
										@click="
											form.tipo_voo_pagamento = 'S'
											erro.tipo_voo_pagamento = ''
											form.adiciona_horimetro_manutencao = ''
										"
										:class="{'btn-info': form.tipo_voo_pagamento == 'S'}"
										class="btn btn-default btn-sm"
									>
										Serviço Aéreo
									</button>
								</div>
								<p class="help-block" v-if="erro.tipo_voo_pagamento">{{ erro.tipo_voo_pagamento }}</p>
							</div>
						</div>
						<div class="row">
							<div
								class="col-xs-12 col-sm-4 col-md-2 form-group"
								v-if="form.tipo_voo_pagamento == 'E'"
								:class="{'has-error': erro.adiciona_horimetro_manutencao != ''}"
							>
								<label>* Adicionar 0.1 ao horímetro?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.adiciona_horimetro_manutencao = '1'
											form.tempo_voo_manutencao = 0.1
											erro.adiciona_horimetro_manutencao = ''
											alteraHorimetroManutencao('+')
										"
										:class="{'btn-info': form.adiciona_horimetro_manutencao == '1'}"
										class="btn btn-default btn-sm"
									>
										Sim
									</button>
									<button
										type="button"
										@click="
											form.adiciona_horimetro_manutencao = '0'
											form.tempo_voo_manutencao = 0.0
											erro.adiciona_horimetro_manutencao = ''
											alteraHorimetroManutencao('-')
										"
										:class="{'btn-info': form.adiciona_horimetro_manutencao == '0'}"
										class="btn btn-default btn-sm"
									>
										Não
									</button>
								</div>
								<p class="help-block" v-if="erro.adiciona_horimetro_manutencao">{{ erro.adiciona_horimetro_manutencao }}</p>
							</div>

							<!-- horimetro manutencao inicial -->
							<div class="col-xs-6 col-md-2 form-group">
								<label>Horimetro de Célula Inicial:</label>
								<money
									type="text"
									v-model="form.horimetro_manutencao"
									disabled="disabled"
									v-bind="_vpercem(1)"
									class="input-sm form-control"
								></money>
							</div>
							<!-- horimetro manutencao Final -->
							<div class="col-xs-6 col-md-2 form-group">
								<label>Horimetro de Célula Final:</label>
								<label
									:disabled="true"
									v-show="form.adiciona_horimetro_manutencao == '1'"
									style="right: 30px; top: 19px"
									class="btn pass-btn-mais-btn btn-link"
									>+ 1</label
								>
								<money
									type="text"
									v-model="form.horimetro_manutencao_final"
									disabled="disabled"
									v-bind="_vpercem(1)"
									class="input-sm form-control"
								></money>
							</div>
							<!-- <div class="col-xs-6 col-md-2 form-group" v-if="form.adiciona_horimetro_manutencao == '1'">
                                <label>Tempo de Manutenção:</label>
                                <money type="text" disabled="disabled" v-model="form.tempo_voo_manutencao" v-bind="_vpercem(1)" class="input-sm form-control"></money>
                            </div> -->
						</div>
					</div>

					<!-- TRIPULAÇÃO -->
					<div>
						<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'tripulacao')" />

						<div class="row">
							<div class="col-lg-3 col-xs-12" v-for="(item, index) in form.tripulacao" :key="index">
								<div class="trecho-borda" style="margin-bottom: 10px; min-height: 280px">
									<div class="row no-print">
										<div class="col-xs-12" style="margin-bottom: 8px">
											<div style="margin-top: 0px; margin-bottom: 0px; font-size: 16px">
												<div v-if="index == 0">
													<span v-if="form.voo_instrucao == '' || form.voo_instrucao == '0'">{{
														_traducao('global', 'primeiroPilotoComando').toUpperCase()
													}}</span>
													<span v-if="form.voo_instrucao == '1'">INSTRUTOR DE VOO</span>
												</div>
												<div v-else>
													<span v-if="item.funcao == 'Copiloto'">{{
														_traducao('global', 'segundoPilotoComando').toUpperCase()
													}}</span>
													<span v-if="item.funcao != 'Copiloto'">{{ item.funcao.toUpperCase() }}</span>
												</div>
												<br />
												<a
													href="#"
													class="pull-right"
													v-if="index >= 1"
													@click.prevent="form.tripulacao.splice(index, 1)"
													style="color: red; font-size: 14px; margin-top: 2px"
												>
													<i class="fa fa-fw fa-trash-o"></i>{{ _traducao('global', 'remover') }}
												</a>

												<p
													class="pull-right"
													v-if="index == 0"
													style="color: #f9f9f9; font-size: 14px; margin-top: 2px; margin-bottom: 0px"
												>
													<span>PILOTO</span>
												</p>
											</div>
										</div>

										<div v-if="item.funcao == ''">
											<div
												class="col-xs-12 form-group"
												:class="{'has-error': item.erroFuncao != ''}"
												style="margin-top: 70px; margin-bottom: 97px"
											>
												<label> <span class="no-print">*</span> {{ _traducao('global', 'escolhaAFuncaoTripulante') }}:</label>
												<select
													class="form-control input-sm"
													v-model="item.funcao"
													@change="carregaUsuariosTripulacao(item.funcao, index, true, false)"
												>
													<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
													<!-- <option value="Piloto em Comando">Piloto em Comando</option> -->
													<option value="Piloto em Instrução">{{ _traducao('global', 'pilotoInstrucao').toUpperCase() }}</option>
													<option value="Copiloto">{{ _traducao('global', 'segundoPilotoComando').toUpperCase() }}</option>
													<option value="Mecânico">{{ _traducao('global', 'mecanico').toUpperCase() }}</option>
													<option value="Operador Aerotático">
														{{ _traducao('global', 'operadorAerotatico').toUpperCase() }}
													</option>
													<option value="TAS">TAS</option>
													<option value="Estagiário">{{ _traducao('global', 'estagiario').toUpperCase() }}</option>
												</select>
												<p class="help-block" v-show="item.erroFuncao != ''">{{ item.erroFuncao }}</p>
											</div>
										</div>

										<div v-if="item.funcao != ''">
											<!-- nome -->
											<div class="col-xs-12 form-group" :class="{'has-error': item.erroUsuario != ''}">
												<label><span class="no-print" v-show="index != 1">*</span> {{ _traducao('global', 'nome') }}:</label>
												<select
													v-if="_isMobile"
													v-model="item.trigrama"
													@blur="carregaANACTrigrama(item.usuarios, item.trigrama, index)"
													class="form-control input-sm"
												>
													<option v-for="(item, idx) in item.usuarios" :key="idx" :value="item.trigrama">
														{{ item.trigrama }} - {{ item.nome }}
													</option>
												</select>
												<flSelect
													:list="item.usuarios"
													v-if="!_isMobile"
													v-show="!item.load"
													:value="item.trigrama == '' ? '' : item.trigrama + ' - ' + item.nome"
													@v-model="(t) => carregaANACTrigrama(item.usuarios, t, index)"
													:return="'trigrama'"
													:label="'descricao'"
												/>

												<flCarregando v-show="item.load" />
												<p class="help-block" v-show="item.erroUsuario != ''">{{ item.erroUsuario }}</p>
											</div>

											<!-- anac -->
											<div class="col-xs-12 form-group">
												<label>ANAC:</label>
												<input type="text" v-model="item.anac" disabled="disabled" class="form-control input-sm" />
											</div>

											<!-- apresentacao -->
											<div class="col-xs-12 form-group" :class="{'has-error': item.erroApresentacao != ''}">
												<label>* {{ _traducao('global', 'apresentacao') }}:</label>
												<a
													href="#"
													class="pull-right"
													v-if="index > 0"
													@click.prevent="item.apresentacao = form.tripulacao[0].apresentacao"
												>
													Copiar
												</a>
												<div>
													<flDateTime
														@v-model="(val) => (item.apresentacao = val)"
														:value="item.apresentacao"
														name="dtOrdemInicio"
														:lang="_getLangDp"
														time="HH:mm"
														:format="_formatDate"
													/>
												</div>
												<p class="help-block" v-show="item.erroApresentacao != ''">{{ item.erroApresentacao }}</p>
											</div>

											<!-- OVN -->
											<!-- <div class="col-xs-12 form-group" v-show="form.ovn == '1' && aeronave.tipo == 'H'" :class="{'has-error': item.erroOVN != ''}">
                                                <label>{{_traducao('global', 'codigo')}} OVN:</label>
                                                <input type="text" v-model="item.codigo_ovn" class="form-control input-sm">
                                                <p class="help-block" v-show="item.erroOVN != ''">{{item.erroOVN}} </p>
                                            </div> -->

											<div class="col-xs-12 form-group" :class="{'has-error': erro.instrutor_voo != ''}">
												<p class="help-block" v-if="erro.instrutor_voo != '' && index == 0">
													{{ erro.instrutor_voo }}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col-lg-3 col-xs-12">
								<div
									class="trecho-borda text-center add"
									@click="clickAddTripulante()"
									style="margin-bottom: 10px; min-height: 280px; cursor: pointer"
								>
									<h3 style="margin-top: 80px">
										{{ _traducao('global', 'adicionar').toUpperCase() }} <br />
										{{ _traducao('global', 'tripulacao').toUpperCase() }}
										<BR />
										<i class="fa fa-fw fa-plus"></i>
									</h3>
								</div>
							</div>
						</div>
					</div>

					<!-- PASSAGEIROS -->
					<div>
						<flCabecalhoForm
							cls="print-titulo-form-20"
							:texto="_traducao('global', 'passageiros') + '/' + _traducao('global', 'vitimas')"
						/>

						<div class="row">
							<div class="col-lg-3 col-xs-12" v-for="(item, index) in form.passageiro" :key="index">
								<!-- PASSAGEIRO -->
								<div class="trecho-borda" style="margin-bottom: 10px; min-height: 230px" v-if="item.tipo == 'P'">
									<div class="row">
										<div class="col-xs-12">
											<label style="color: #1976d2">{{ _traducao('global', 'passageiro').toUpperCase() }}</label>
											<a
												href="#"
												class="pull-right"
												@click.prevent="form.passageiro.splice(index, 1)"
												style="color: red; font-size: 14px; margin-top: 2px"
											>
												<i class="fa fa-fw fa-trash-o"></i>{{ _traducao('global', 'remover') }}
											</a>
										</div>
									</div>

									<div class="row no-print">
										<!-- nome -->
										<div class="col-xs-12 form-group" :class="{'has-error': item.nomeErro}">
											<label><span class="no-print">*</span> {{ _traducao('global', 'nome') }}:</label>
											<input type="text" v-model="item.nome" class="form-control input-sm" />
											<p class="help-block" v-show="item.nomeErro">{{ item.nomeErro }}</p>
										</div>
									</div>
									<div class="row">
										<!-- orgao -->
										<div class="col-xs-6 form-group" :class="{'has-error': item.orgaoErro}">
											<label> <span class="no-print">*</span> {{ _traducao('global', 'orgao') }}:</label>
											<input type="text" v-model="item.orgao" class="form-control input-sm" />
											<p class="help-block" v-show="item.orgaoErro">{{ item.orgaoErro }}</p>
										</div>

										<!-- cargo -->
										<div class="col-xs-6 form-group" :class="{'has-error': item.cargoErro}">
											<label> <span class="no-print">*</span> {{ _traducao('menuSolicitaApoio', 'menuCargo') }}:</label>
											<input type="text" v-model="item.cargo" class="form-control input-sm" />
											<p class="help-block" v-show="item.cargoErro">{{ item.cargoErro }}</p>
										</div>
									</div>
									<div class="row">
										<!-- CPF -->
										<div class="col-xs-6 form-group" :class="{'has-error': item.cpfErro}">
											<label>{{ _traducao('menuAGnovoUsuario', 'menuAGcpf') }}:</label>
											<input type="text" v-model="item.cpf" v-mask="_vdocumento" class="form-control input-sm" />
											<p class="help-block" v-show="item.cpfErro">{{ item.cpfErro }}</p>
										</div>

										<!-- telefone -->
										<div class="col-xs-6 form-group" :class="{'has-error': item.telefoneErro}">
											<label>{{ _traducao('global', 'telefone') }}:</label>
											<input type="text" v-model="item.telefone" v-mask="_vtelefone" class="form-control input-sm" />
											<p class="help-block" v-show="item.telefoneErro">{{ item.telefoneErro }}</p>
										</div>
									</div>
								</div>

								<!-- VITIMA -->
								<div class="trecho-borda" style="margin-bottom: 10px; min-height: 230px" v-if="item.tipo == 'V'">
									<div class="row">
										<div class="col-xs-12">
											<label style="color: #1976d2">{{ _traducao('global', 'vitima').toUpperCase() }}</label>

											<a
												href="#"
												class="pull-right"
												@click.prevent="form.passageiro.splice(index, 1)"
												style="color: red; font-size: 14px; margin-top: 2px"
											>
												<i class="fa fa-fw fa-trash-o"></i>{{ _traducao('global', 'remover') }}
											</a>
										</div>
									</div>
									<div class="row">
										<!-- nome -->
										<div class="col-xs-9 form-group">
											<label>{{ _traducao('global', 'nome') }}:</label>
											<input type="text" v-model="item.nome" class="form-control input-sm" />
										</div>

										<!-- SEXO -->
										<div class="col-xs-3 form-group" style="padding-left: 0" :class="{'has-error': item.sexoErro}">
											<label><span class="no-print">*</span> {{ _traducao('menuAGcadAluno', 'menuAGalunoSexo') }}:</label><br />
											<div class="btn-group" role="group btn-block" style="width: 100%">
												<button
													type="button"
													@click="item.sexo = 'F'"
													style="width: 50%; margin-top: 0px"
													class="btn btn-sm btn-block btn-default"
													:class="{'btn-success': item.sexo == 'F'}"
												>
													F
												</button>
												<button
													type="button"
													@click="item.sexo = 'M'"
													style="width: 50%; margin-top: 0px"
													class="btn btn-sm btn-block btn-default"
													:class="{'btn-success': item.sexo == 'M'}"
												>
													M
												</button>
											</div>
											<p class="help-block" v-show="item.sexoErro">{{ item.sexoErro }}</p>
										</div>
									</div>

									<div class="row">
										<!-- DATA DE NASCIMENTO -->
										<div class="col-xs-6 form-group">
											<label>{{ _traducao('global', 'dataNascimento') }}:</label>
											<flDateTime
												@v-model="
													(val) => {
														item.data_nascimento = val
														alteraIdade(val)
													}
												"
												:value="item.data_nascimento"
												name="dataNascimento"
												:lang="_getLangDp"
												:format="_formatDate"
											/>
										</div>
										<!-- IDADE APARENTE -->
										<div class="col-xs-6 form-group" :class="{'has-error': item.idadeErro}">
											<label> <span class="no-print">*</span> {{ _traducao('global', 'idadeAparente') }}:</label>
											<input type="text" v-model="item.idade_aparente" class="form-control input-sm" />
											<p class="help-block" v-show="item.idadeErro">{{ item.idadeErro }}</p>
										</div>
									</div>

									<div class="row">
										<!-- CPF -->
										<div class="col-xs-6 form-group">
											<label>{{ _traducao('menuMatricula', 'cpf') }}:</label>
											<input type="text" v-model="item.cpf" v-mask="_vdocumento" class="form-control input-sm" />
										</div>

										<!-- TELEFONE -->
										<div class="col-xs-6 form-group">
											<label>{{ _traducao('global', 'telefone') }}:</label>
											<input type="text" v-mask="_vtelefone" v-model="item.telefone" class="form-control input-sm" />
										</div>
									</div>
								</div>
							</div>

							<div class="col-lg-3 col-xs-12">
								<div
									class="trecho-borda text-center add"
									@click="clickAddPassageiro('P')"
									style="margin-bottom: 10px; min-height: 230px; cursor: pointer"
								>
									<h3 style="margin-top: 60px">
										{{ _traducao('global', 'adicionar').toUpperCase() }} <br />
										{{ _traducao('global', 'passageiro').toUpperCase() }}
										<BR />
										<i class="fa fa-fw fa-plus"></i>
									</h3>
								</div>
							</div>
							<div class="col-lg-3 col-xs-12">
								<div
									class="trecho-borda text-center add"
									@click="clickAddPassageiro('V')"
									style="margin-bottom: 10px; min-height: 230px; cursor: pointer"
								>
									<h3 style="margin-top: 60px">
										{{ _traducao('global', 'adicionar').toUpperCase() }} <br />
										{{ _traducao('global', 'vitima').toUpperCase() }}
										<BR />
										<i class="fa fa-fw fa-plus"></i>
									</h3>
								</div>
							</div>
						</div>
					</div>

					<!-- CARGA TRANSPORTADA -->
					<div>
						<flCabecalhoForm
							:msg="_traducao('global', 'obrigatorio')"
							cls="print-titulo-form-40"
							:texto="_traducao('global', 'cargaTransportada')"
						/>

						<div class="row">
							<!-- ha carga a ser transportada -->
							<div class="col-xs-12 form-group" :class="{'has-error': erro.carga != ''}">
								<label>* {{ _traducao('global', 'houveCargaTransportada') }}</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.carga = 'S'
											erro.carga = ''
										"
										:class="{'btn-info': form.carga == 'S'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.carga = 'N'
											erro.carga = ''
										"
										:class="{'btn-info': form.carga == 'N'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-show="erro.carga != ''">{{ erro.carga }}</p>
							</div>
						</div>

						<div v-show="form.carga == 'S'">
							<div class="row">
								<!-- Descrição da Carga -->
								<div class="col-xs-12 col-md-7 form-group" :class="{'has-error': erro.descricao_carga != ''}">
									<label> <span>*</span> {{ _traducao('global', 'descricaoDaCarga') }}:</label>
									<textarea v-model="form.descricao_carga" class="form-control input-sm" rows="3"> </textarea>
									<p class="help-block" v-show="erro.descricao_carga != ''">{{ erro.descricao_carga }}</p>
								</div>

								<!-- Peso Aproximado -->
								<div class="col-xs-12 col-md-3 form-group" :class="{'has-error': erro.peso_carga != ''}">
									<label> <span>*</span> {{ _traducao('global', 'pesoAprox') }}:</label>
									<input
										type="text"
										v-model="form.peso_carga"
										v-mask="'00000000'"
										@keyup="erro.peso_carga = ''"
										class="form-control input-sm"
									/>
									<p class="help-block" v-show="erro.peso_carga">{{ erro.peso_carga }}</p>
								</div>

								<div class="col-xs-12 col-md-2 text-center form-group" :class="{'has-error': erro.carga_liquida != ''}">
									<label>* {{ _traducao('global', 'cargaLiquida') }}</label>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button
											type="button"
											@click="
												form.carga_liquida = 'S'
												erro.carga_liquida = ''
											"
											:class="{'btn-info': form.carga_liquida == 'S'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'sim') }}
										</button>
										<button
											type="button"
											@click="
												form.carga_liquida = 'N'
												erro.carga_liquida = ''
											"
											:class="{'btn-info': form.carga_liquida == 'N'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'nao') }}
										</button>
									</div>
									<p class="help-block" v-show="erro.carga_liquida">{{ erro.carga_liquida }}</p>
								</div>
							</div>
						</div>
					</div>

					<!-- DISCREPANCIAS -->
					<div>
						<flCabecalhoForm cls="print-titulo-form-20" :texto="'Discrepâncias Técnicas'" />
						<div class="row" v-for="(item, index) in form.discrepancia" :key="index">
							<!-- nome -->
							<div class="col-md-4 col-xm-12">
								<div class="row">
									<div class="col-xs-12 form-group" :class="{'has-error': item.erroTipo != ''}">
										<label><span class="no-print">*</span> {{ _traducao('global', 'tipo') }}:</label>
										<a
											href="#"
											class="pull-right"
											v-if="item.id == 0"
											@click.prevent="form.discrepancia.splice(index, 1)"
											style="color: red; font-size: 14px; margin-top: 2px"
										>
											<i class="fa fa-fw fa-trash-o"></i>Remover
										</a>
										<select v-model="item.tipo" class="form-control input-sm">
											<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
											<option value="DISCREPANCIA">{{ _traducao('global', 'discrepancia').toUpperCase() }}</option>
											<option value="OCORRENCIA">{{ _traducao('menuVoo', 'menuVocorrencia').toUpperCase() }}</option>
										</select>
										<p class="help-block" v-show="item.erroTipo != ''">{{ item.erroTipo }}</p>
									</div>

									<div class="col-xs-12 form-group" :class="{'has-error': item.erroUsuario != ''}">
										<label><span class="no-print">*</span> {{ _traducao('global', 'nome') }}:</label>
										<select
											v-if="_isMobile"
											v-model="item.trigrama"
											@blur="getANAC(_pilotos_mecanicos, item.trigrama, index)"
											class="form-control input-sm"
										>
											<option v-for="(p, x) in _pilotos_mecanicos" :key="x" :value="p.trigrama">
												{{ p.trigrama }} - {{ p.nome }}
											</option>
										</select>
										<flSelect
											:list="_pilotos_mecanicos"
											v-if="!_isMobile"
											:value="item.trigrama == '' ? '' : item.trigrama + ' - ' + item.nome"
											@v-model="(trigama) => getANAC(_pilotos_mecanicos, trigama, index)"
											:return="'trigrama'"
											:label="'descricao'"
										/>

										<p class="help-block" v-show="item.erroUsuario != ''">{{ item.erroUsuario }}</p>
									</div>

									<!-- anac -->
									<div class="col-xs-12 form-group">
										<label>ANAC:</label>
										<input type="text" class="form-control input-sm" v-model="item.anac" disabled="disabled" />
									</div>
								</div>
							</div>

							<!-- descricao -->
							<div class="col-md-8 col-xs-12" :class="{'has-error': item.erroDescricao != ''}">
								<label>* {{ _traducao('global', 'descricao') }}:</label>
								<textarea v-model="item.descricao" class="form-control input-sm" rows="9"></textarea>
								<p class="help-block" v-show="item.erroDescricao != ''">{{ item.erroDescricao }}</p>
							</div>

							<!-- acoes tomadas -->
							<div class="col-xs-12">
								<div
									v-if="item.acao_discrepancia.length > 0"
									style="border: 1px solid #ddd; padding: 8px; margin-top: 4px; margin-bottom: 8px"
								>
									<!-- <hr style="margin-bottom:4px; margin-top:4px" /> -->
									<div class="row" v-if="item.acao_discrepancia.length > 0">
										<div class="col-xs-12 text-center">
											<strong>AÇÕES TOMADAS</strong>
										</div>
									</div>
									<hr style="margin-bottom: 4px; margin-top: 4px" />

									<div v-for="(itAcao, idxAcao) in item.acao_discrepancia" :key="idxAcao">
										<div class="row">
											<div class="col-xs-2">
												<strong>Ação:</strong> <br />
												<span v-if="itAcao.tipo_acao == 'C'">{{ _traducao('global', 'acaoCorretiva').toUpperCase() }}</span>
												<span v-if="itAcao.tipo_acao == 'P'">{{ _traducao('global', 'acaoPreventiva').toUpperCase() }}</span>
												<span v-if="itAcao.tipo_acao == 'M'">{{ _traducao('global', 'monitoramento').toUpperCase() }}</span>
												<span v-if="itAcao.tipo_acao == 'I'">{{
													_traducao('global', 'indisponibilizarAeronave').toUpperCase()
												}}</span>
											</div>
											<div class="col-xs-3">
												<strong>Nome - ANAC:</strong> <br />
												{{ itAcao.nome }} - {{ itAcao.codigo_anac }}
											</div>
											<div class="col-xs-3">
												<strong>Data:</strong> <br />
												{{ itAcao.data_cadastro | dataTempo }}
											</div>
											<div class="col-xs-4">
												<strong>Descrição:</strong> <br />
												{{ itAcao.descricao_acao }}
											</div>
										</div>
									</div>

									<div v-if="item.data_conclusao">
										<hr style="margin-bottom: 4px; margin-top: 4px" />
										<div class="row">
											<div class="col-xs-12 text-center">
												<strong>CONCLUSÃO</strong>
											</div>
										</div>
										<hr style="margin-bottom: 4px; margin-top: 4px" />

										<div class="row">
											<div class="col-xs-2">
												<strong>Data:</strong><br />
												{{ item.data_conclusao | dataTempo }}
											</div>
											<div class="col-xs-3">
												<strong>{{ _traducao('global', 'nome') }} - ANAC:</strong> <br />
												{{ item.nome_usuario_conclusao }} - {{ item.anac_usuario_conclusao | na }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12" style="margin-top: 10px">
								<button class="btn btn-info btn-sm" type="button" @click="clickAddDiscrepancia()">
									<i class="fa fa-fw fa-plus"></i>{{ _traducao('global', 'adicionarDiscrepancia').toUpperCase() }}
								</button>
							</div>
						</div>
					</div>

					<!-- OCORRÊNCIAS -->
					<div>
						<flCabecalhoForm cls="print-titulo-form-20" :texto="'Ocorrências'" />
						<div v-for="(item, index) in form.ocorrencias" :key="index">
							<div class="row">
								<!-- data -->
								<div class="col-md-3 col-xm-12 form-group" :class="{'has-error': item.erro_data != ''}">
									<label><span class="no-print">*</span> Data:</label>
									<a
										href="#"
										class="pull-right"
										v-if="item.id == 0"
										@click.prevent="form.ocorrencias.splice(index, 1)"
										style="color: red; font-size: 14px; margin-top: 2px"
									>
										<i class="fa fa-fw fa-trash-o"></i>Remover
									</a>
									<flDateTime
										@v-model="(val) => (item.data = val)"
										:value="item.data"
										name="dtOrdemInicio"
										:lang="_getLangDp"
										time="HH:mm"
										:format="_formatDate"
									/>
									<!-- <input type="text" class="form-control input-sm" v-model="item.data"> -->
									<p class="help-block" v-show="item.erro_data != ''">{{ item.erro_data }}</p>
								</div>

								<!-- LOCAL -->
								<div class="col-md-9 col-xm-12 form-group" :class="{'has-error': item.erro_local != ''}">
									<label
										><span class="no-print">*</span> Local:
										<i
											class="fa fa-info-circle"
											v-tooltip="
												'Local da ocorrência, necessariamente, pelo indicativo de localidade ou coordenada geográfica se em solo e, obrigatoriamente por coordenada geográfica se em voo.'
											"
										></i
									></label>
									<input type="text" class="form-control input-sm" v-model="item.local" />
									<p class="help-block" v-show="item.erro_local != ''">{{ item.erro_local }}</p>
								</div>
							</div>
							<div class="row">
								<!-- Códico classificacao -->
								<div class="col-md-3 col-xm-12 form-group" :class="{'has-error': item.erro_codigo_classificacao != ''}">
									<label><span class="no-print">*</span>Código Classificação:</label>
									<select class="form-control input-sm" v-model="item.codigo_classificacao">
										<option value="">ESCOLHA</option>
										<option value="HTSAN">HTSAN</option>
										<option value="AVSEC">AVSEC</option>
										<option value="PBSEC">PBSEC</option>
										<option value="OTR">OTR</option>
									</select>
									<p class="help-block" v-show="item.erro_codigo_classificacao != ''">{{ item.erro_codigo_classificacao }}</p>
								</div>

								<!-- Qualificação civil -->
								<div class="col-md-9 col-xm-12 form-group" :class="{'has-error': item.erro_qualificacao_civil != ''}">
									<label
										><span class="no-print">*</span> Qualificação Civil:
										<i
											class="fa fa-info-circle"
											v-tooltip="
												'Melhor qualificação civil possível das pessoas envolvidas (nome completo, documento de identificação utilizado para embarque; nacionalidade e data de nascimento, entre outros).'
											"
										></i
									></label>
									<input type="text" class="form-control input-sm" v-model="item.qualificacao_civil" />
									<p class="help-block" v-show="item.erro_qualificacao_civil != ''">{{ item.erro_qualificacao_civil }}</p>
								</div>
							</div>

							<div class="row">
								<!-- DESCRIÇÃO DOS FATOS -->
								<div class="col-md-12 col-xm-12 form-group" :class="{'has-error': item.erro_descricao_fatos != ''}">
									<label
										><span class="no-print">*</span> Descrição dos Fatos:
										<i
											class="fa fa-info-circle"
											v-tooltip="'Descrição dos fatos, necessariamente, informando o que e como se deu a ocorrência.'"
										></i
									></label>
									<textarea type="text" class="form-control input-sm" v-model="item.descricao_fatos"></textarea>
									<p class="help-block" v-show="item.erro_descricao_fatos != ''">{{ item.erro_descricao_fatos }}</p>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12" style="margin-top: 10px">
								<button class="btn btn-info btn-sm" type="button" @click="clickAddOcorrencia()">
									<i class="fa fa-fw fa-plus"></i> ADICIONAR OCORRÊNCIA
								</button>
							</div>
						</div>
					</div>

					<!-- DADOS MISSAO -->
					<div>
						<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'dadosDaMissao')" />

						<div class="row">
							<div class="col-xs-12 col-md-2 form-group" :class="{'has-error': erro.base != ''}">
								<label>* {{ _traducao('global', 'base') }}:</label>
								<select v-model="form.base" class="form-control input-sm">
									<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
									<option v-for="item in bases" :key="item.descricao" :value="item.id">{{ item.descricao }}</option>
								</select>
								<p class="help-block" v-if="erro.base">{{ erro.base }}</p>
							</div>

							<div class="col-xs-12 col-md-2 form-group" :class="{'has-error': erro.numero_chamada != ''}">
								<label>* Nº {{ _traducao('global', 'chamada') }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									placeholder="0000-00000000-0"
									v-mask="'0000-00000000-0'"
									v-model="form.numero_chamada"
								/>
								<p class="help-block" v-if="erro.chamada != ''">{{ erro.numero_chamada }}</p>
							</div>

							<div class="col-xs-12 col-md-2 form-group" :class="{'has-error': erro.numero_bo != ''}">
								<label>Nº CIOPS:</label>
								<input
									type="text"
									class="form-control input-sm"
									placeholder="0000-000000000-000"
									v-mask="'0000-000000000-000'"
									v-model="form.numero_bo"
								/>
							</div>

							<div class="col-xs-12 col-md-2 form-group" :class="{'has-error': erro.diario_fisico != ''}">
								<label>* Nº Diário de Bordo Físico:</label>
								<input
									type="text"
									class="form-control input-sm"
									placeholder="000/AAAAA/0000"
									v-mask="'000/AAAAA/0000'"
									v-model="form.diario_fisico"
								/>
							</div>

							<div class="col-xs-12 col-md-4 form-group" :class="{'has-error': erro.objetivo_alcancado != ''}">
								<label>* Os objetivos da missão foram alcançados?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.objetivo_alcancado = 'S'
											erro.objetivo_alcancado = ''
										"
										:class="{'btn-info': form.objetivo_alcancado == 'S'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.objetivo_alcancado = 'P'
											erro.objetivo_alcancado = ''
										"
										:class="{'btn-info': form.objetivo_alcancado == 'P'}"
										class="btn btn-default btn-sm"
									>
										Parcial
									</button>
									<button
										type="button"
										@click="
											form.objetivo_alcancado = 'N'
											erro.objetivo_alcancado = ''
										"
										:class="{'btn-info': form.objetivo_alcancado == 'N'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.objetivo_alcancado">{{ erro.objetivo_alcancado }}</p>
							</div>
						</div>

						<hr />

						<!-- SE FOR PMSP -->
						<div class="row" v-if="_idCliente == 14">
							<!-- AUTO LOCALIZACAO -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Auto Localização:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.auto_localizado += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.auto_localizado == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.auto_localizado -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.auto_localizado"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- ARMAS APREENDIDAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Armas Apreendidas:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.arma_apreendida += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.arma_apreendida == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.arma_apreendida -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.arma_apreendida"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- PESSOAS DETIDAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Pessoas Detidas:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.pessoa_detida += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pessoa_detida == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pessoa_detida -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pessoa_detida"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- PESSOAS SALVAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Pessoas Salvas:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.pessoa_salva += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pessoa_salva == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pessoa_salva -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pessoa_salva"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- VALOR RECUPERADO -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Valor Recuperado:</label>
								<br />
								<money
									type="text"
									v-model="form.valor_recuperado"
									v-bind="_vpercem(2)"
									class="form-control text-right input-sm"
								></money>
							</div>

							<div class="col-xs-12">
								<hr />
							</div>
						</div>

						<div class="row">
							<!-- TIPO DE MISSAO NATUREZA DO VOO -->
							<div class="col-xs-12 col-md-6 form-group" :class="{'has-error': erro.tipo_missao != ''}">
								<label>* Tipo da Missão:</label>
								<v-select
									v-model="form.tipo_missao"
									class="form-control input-sm"
									label="descricao"
									:options="tiposDeMissoes"
								></v-select>
								<p class="help-block" v-if="erro.tipo_missao != ''">{{ erro.tipo_missao }}</p>
							</div>
							<!-- DESCRICAO DA MISSAO -->
							<!-- <div class="col-xs-12 col-md-6 form-group" :class="{'has-error' : erro.descricao != ''}">
                                <label>* {{_traducao('menuAGtipoMissao', 'menuAGdescMissao2')}}:</label>
								<v-select v-model="form.descricao" class="form-control input-sm" :options="descricoes"></v-select>
                                <p class="help-block" v-if="erro.descricao != ''">{{erro.descricao}}</p>
                            </div> -->
						</div>
						<div class="row" v-if="form.tipo_missao.id == '4'">
							<div class="col-xs-12 col-md-4 form-group" :class="{'has-error': erro.tipo_classificacao != ''}">
								<label>* Qual o tipo?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.tipo_classificacao = 'R'
											erro.tipo_classificacao = ''
										"
										:class="{'btn-info': form.tipo_classificacao == 'R'}"
										class="btn btn-default btn-sm"
									>
										Repressão
									</button>
									<button
										type="button"
										@click="
											form.tipo_classificacao = 'P'
											erro.tipo_classificacao = ''
										"
										:class="{'btn-info': form.tipo_classificacao == 'P'}"
										class="btn btn-default btn-sm"
									>
										Prevenção
									</button>
								</div>
								<p class="help-block" v-if="erro.tipo_classificacao">{{ erro.tipo_classificacao }}</p>
							</div>
						</div>

						<!-- TRANSPLANTE DE ORGÃOS E TECIDOS -->
						<div class="row" v-if="form.tipo_missao" v-show="form.tipo_missao.descricao == 'TRANSPORTE DE ÓRGÃOS E TECIDOS' || form.tipo_missao.descricao == 'SAÚDE / SOCORRO'">
							<!-- CORACAO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'coracao') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.coracao += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.coracao == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.coracao -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.coracao"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- RIM -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'rim') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.rim += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.rim == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.rim -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.rim"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- FIGADO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'figado') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.figado += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.figado == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.figado -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.figado"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- CORNEA -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'cornea') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.cornea += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.cornea == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.cornea -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.cornea"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- ESCLERO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'esclero') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.esclero += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.esclero == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.esclero -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.esclero"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- BAÇO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'baco') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.baco += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.baco == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.baco -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.baco"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<!-- MEIO AMBIENTE, BUSCA E SALVAMENTO E COMBATE A INCÊNCIDO -->
						<div class="row">
							<!-- BRIGADISTAS -->
							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="form.tipo_missao.descricao == 'MEIO AMBIENTE'"
							>
								<label>{{ _traducao('global', 'brigadistas') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.brigadista += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.brigadista == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.brigadista -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.brigadista"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="form.tipo_missao.descricao == 'MEIO AMBIENTE'"
								:class="{'has-error': erro.existe_unidade_conservacao != ''}"
							>
								<label>* Unidade de Conservação?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.existe_unidade_conservacao = '1'
											erro.existe_unidade_conservacao = ''
										"
										:class="{'btn-info': form.existe_unidade_conservacao == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.existe_unidade_conservacao = '0'
											erro.existe_unidade_conservacao = ''
										"
										:class="{'btn-info': form.existe_unidade_conservacao == '0'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.existe_unidade_conservacao != ''">{{ erro.existe_unidade_conservacao }}</p>
							</div>

							<!-- UNIDADE DE CONSERVAÇÃO -->
							<div
								class="col-xs-12 col-md-6 form-group"
								v-if="form.tipo_missao"
								v-show="form.tipo_missao.descricao == 'MEIO AMBIENTE'"
							>
								<div v-if="form.existe_unidade_conservacao == '1'">
									<div class="row" v-for="(un, idxUn) in form.unidade_conservacao" :key="idxUn">
										<div class="col-xs-12 form-group" :class="{'has-error': un.erro != ''}">
											<label>* {{ _traducao('global', 'unidadeDeConservacao') }}:</label>
											<a
												href="#"
												class="pull-right"
												@click.prevent="form.unidade_conservacao.splice(idxUn, 1)"
												v-if="idxUn > 0"
												style="color: red; font-size: 12px"
											>
												<i class="fa fa-fw fa-trash-o"></i>Remover
											</a>

											<v-select
												v-model="un.obj"
												class="form-control input-sm"
												:options="unidadesConservacao"
												label="sigla"
											></v-select>

											<p class="help-block" v-if="un.erro != ''">{{ un.erro }}</p>
										</div>
									</div>
								</div>

								<div class="row" v-if="form.existe_unidade_conservacao == '1'">
									<div class="col-xs-12" style="margin-top: 10px">
										<button class="btn btn-info btn-sm" type="button" @click="form.unidade_conservacao.push({obj: '', erro: ''})">
											<i class="fa fa-fw fa-plus"></i>ADICIONAR UNIDADE
										</button>
									</div>
								</div>
							</div>

							<!--BAMBI
                            <div class="col-xs-12 col-md-2 form-group" v-if="form.tipo_missao" v-show="form.tipo_missao.descricao == 'MEIO AMBIENTE' || form.tipo_missao.descricao == 'COMBATE A INCÊNDIO'">
                                <label>Bambi Bucket:</label>
                                <br/>
                                <button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.bambi += 1; form.gancho += 1">
                                    <i style="margin-top:7px" class="fa fa-plus fa-fw"></i>
                                </button>
                                <button type="button" :disabled="form.bambi == 0" class="pass-btn-menos-btn btn-link text-center" @click.prevent="form.bambi -= 1; form.gancho -= 1">
                                    <i style="margin-top:8px" class="fa fa-minus fa-fw"></i>
                                </button>
                                <input type="text" :value="form.bambi" style="cursor:default;background:#FFF;" v-mask="'00'" disabled="disabled" class="form-control text-center input-sm">
                            </div> -->

							<!-- BUSCA E SALVAMENTO -->
							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="form.tipo_missao.descricao == 'BUSCA E SALVAMENTO'"
							>
								<label>{{ _traducao('global', 'socorridos') }}:</label>
								<br />
								<button type="button" class="pass-btn-mais-btn btn-link text-center" @click.prevent="form.socorrido += 1">
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.socorrido == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.socorrido -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.socorrido"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<hr />

						<!-- CLASSIFICAÇÃO E SUBCLASSIFICAÇÃO -->
						<div>
							<div class="row">
								<div class="col-xs-12 col-md-12 form-group" :class="{'has-error': erro.classificacao != ''}">
									<label>* {{ _traducao('global', 'classificacao') }}:</label>
									<v-select
										v-model="form.classificacao"
										class="form-control input-sm"
										:options="listaClasFilter"
										label="descricao"
									></v-select>
									<p class="help-block" v-if="erro.classificacao != ''">{{ erro.classificacao }}</p>
								</div>

								<div class="col-xs-12 col-md-12 form-group" :class="{'has-error': erro.subclassificacao != ''}" v-show="exibir">
									<label>* {{ _traducao('global', 'subclassificacao') }}:</label>
									<v-select
										v-model="form.subclassificacao"
										class="form-control input-sm"
										:options="listaSubFilter"
										label="descricao"
									></v-select>
									<p class="help-block" v-if="erro.subclassificacao != ''">{{ erro.subclassificacao }}</p>
								</div>

								<!-- <div class="col-xs-12 col-md-12 form-group" :class="{'has-error' : erro.divisao != ''}" v-show="listaDivFilter != ''">
									<label>Divisão:</label>
									<v-select v-model="form.divisao" class="form-control input-sm" :options="listaDivFilter" label="descricao"></v-select>
									<p class="help-block" v-if="erro.divisao != ''">{{erro.divisao}}</p>
								</div> -->
							</div>
						</div>

						<hr />

						<!-- CONTEXTO OPERATIVO -->
						<div>
							<div class="row">
								<div class="col-xs-12 form-group" :class="{'has-error': erro.houve_contexto != ''}">
									<label>* {{ _traducao('global', 'haContextoOperativo') }}</label>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button
											type="button"
											@click="
												form.houve_contexto = '1'
												erro.houve_contexto = ''
											"
											:class="{'btn-info': form.houve_contexto == '1'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'sim') }}
										</button>
										<button
											type="button"
											@click="
												form.houve_contexto = '0'
												erro.houve_contexto = ''
											"
											:class="{'btn-info': form.houve_contexto == '0'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'nao') }}
										</button>
									</div>
									<p class="help-block" v-if="erro.houve_contexto != ''">{{ erro.houve_contexto }}</p>
								</div>
							</div>
							<div class="row" v-if="form.houve_contexto == '1'">
								<div class="col-xs-12 col-md-6 form-group" :class="{'has-error': erro.contexto_operativo != ''}">
									<label>* {{ _traducao('global', 'contextoOperativo') }}</label>
									<v-select
										v-model="form.contexto_operativo"
										class="form-control input-sm"
										:options="contextos"
										label="descricao"
									></v-select>
									<p class="help-block" v-if="erro.contexto_operativo != ''">{{ erro.contexto_operativo }}</p>
								</div>
							</div>
						</div>

						<hr />

						<!-- ORGÃOS APOIADOS E UNIDADES -->
						<div class="form-group">
							<label v-show="form.orgao.length == 0">* {{ _traducao('global', 'orgaosApoiados') }}:</label>
							<div v-for="(itOrgao, idxOrgao) in form.orgao" :key="idxOrgao">
								<div class="row">
									<div
										class="col-xs-2 col-md-2 form-group"
										:class="{'has-error': itOrgao.erroTempoVoo != ''}"
										v-if="_idCliente == 14"
									>
										<label>* Tempo:</label>
										<money type="text" v-model="itOrgao.tempo_voo" v-bind="_vpercem(2)" class="input-sm form-control"></money>
										<p class="help-block" v-if="itOrgao.erroTempoVoo != ''">{{ itOrgao.erroTempoVoo }}</p>
									</div>

									<!-- orgao -->
									<div class="col-xs-6 col-md-6 form-group" :class="{'has-error': itOrgao.erroOrgao != ''}">
										<label>* {{ _traducao('global', 'orgaoApoiado') }}:</label>
										<a
											href="#"
											class="pull-right btn-remover-orgao"
											@click.prevent="form.orgao.splice(idxOrgao, 1)"
											type="button"
										>
											<i class="fa fa-trash fa-fw"></i>{{ _traducao('global', 'remover') }}
										</a>
										<div :style="{'z-index': 1000 - idxOrgao}">
											<v-select
												v-model="form.orgao[idxOrgao].orgao"
												class="form-control input-sm"
												:options="orgaos"
												label="sigla"
											></v-select>
										</div>

										<p class="help-block" v-if="itOrgao.erroOrgao != ''">{{ itOrgao.erroOrgao }}</p>
									</div>

									<!-- unidades -->
									<div class="col-xs-6 col-md-6 form-group" v-if="form.orgao[idxOrgao].orgao != ''">
										<div v-if="form.orgao[idxOrgao].orgao.unidade.length > 0">
											<div
												class="form-group"
												:class="{'has-error': unid.erroUnidade != ''}"
												v-for="(unid, indexUnid) in form.orgao[idxOrgao].unidade"
												:key="indexUnid"
											>
												<label>{{ _traducao('global', 'unidade') }}:</label>
												<a
													href="#"
													class="pull-right btn-remover-orgao"
													@click.prevent="form.orgao[idxOrgao].unidade.splice(indexUnid, 1)"
													type="button"
												>
													<i class="fa fa-trash fa-fw"></i>{{ _traducao('global', 'remover') }}
												</a>
												<div :style="{'z-index': 1000 - indexUnid}">
													<v-select
														v-show="!loadUnidade"
														v-model="form.orgao[idxOrgao].unidade[indexUnid].unidade"
														class="form-control input-sm"
														:options="form.orgao[idxOrgao].orgao.unidade"
														label="descricao"
													></v-select>
												</div>
												<p class="help-block" v-if="unid.erroUnidade != ''">{{ unid.erroUnidade }}</p>
											</div>

											<div>
												<span v-if="form.orgao[idxOrgao].unidade.length == 0">
													<label style="color: #f9f9f9">{{ _traducao('global', 'unidades') }}:</label>
													<br />
												</span>
												<button
													@click="form.orgao[idxOrgao].unidade.push({unidade: '', erroUnidade: ''})"
													class="btn btn-info btn-sm"
													type="button"
												>
													<i class="fa fa-plus fa-fw"></i>{{ _traducao('global', 'adicionarUnidade').toUpperCase() }}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" :class="{'has-error': erro.orgao}">
								<div class="col-xs-12">
									<button class="btn btn-info btn-sm" type="button" @click="clickAddOrgao">
										<i class="fa fa-plus fa-fw"></i>{{ _traducao('global', 'adicionarOrgao').toUpperCase() }}
									</button>

									<p class="help-block" v-if="erro.orgao != ''">{{ erro.orgao }}</p>
								</div>
							</div>
						</div>
					</div>

					<!-- OBSERVACAO -->
					<div>
						<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'observacao')" />

						<div class="row">
							<div class="col-xs-12">
								<textarea v-model="form.observacao" class="form-control input-sm" rows="5"></textarea>
							</div>
						</div>
					</div>

					<!-- BTN SALVAR -->
					<div class="row" style="margin-top: 20px; margin-bottom: 30px">
						<div class="col-md-8"></div>
						<div class="col-xs-12 col-md-4" :class="{'has-error': erro.diurnoNortuno != ''}">
							<p class="help-block text-right" v-if="erro.diurnoNortuno != ''">{{ erro.diurnoNortuno }}</p>
							<button
								class="btn btn-block btn-success pull-right"
								:disabled="validaDisabledSalvar()"
								type="button"
								@click="clickExibeModalSalvar()"
							>
								<i class="fa fa-fw fa-check"></i>
								<span v-if="!editar && !assinar">{{ _traducao('global', 'finalizarTracho').toUpperCase() }}</span>
								<span v-if="editar && !assinar">{{ _traducao('global', 'atualizarTrecho').toUpperCase() }}</span>
								<span v-if="assinar">{{ _traducao('global', 'assinarESalvarTrecho').toUpperCase() }}</span>
							</button>
						</div>
					</div>
				</div>
			</div>

			<flOrigemVoo
				ref="origemVoo"
				@selecionou-ordem="(data) => ordemSelecionada(data)"
				@selecionou-despacho="(data) => despachoSelecionado(data)"
			/>

			<!-- MODAL COM A VOLTA PRA LISTA -->
			<modal name="modal-ordem-tempo-expirado">
				<h4 class="modal-title">
					{{ _traducao('global', 'tempoDePreenchimento').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12 text-center">
						<h3>
							{{ _traducao('global', 'desejaContinuarAPrrencher') }}
						</h3>
					</div>
				</div>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-6">
						<button class="btn pull-left btn-default" type="button" @click="voltaLista()">
							<i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>{{ _traducao('global', 'voltar') }}
						</button>
					</div>
					<div class="col-xs-6">
						<button class="btn pull-right btn-success" type="button" @click="clickContinuaPreenchendo()">
							<i class="fa fa-fw fa-check"></i>{{ _traducao('global', 'continuar') }}
						</button>
					</div>
				</div>
			</modal>

			<!-- MODAL PARA CONFIRMAR A SALVACAO -->
			<modal ref="modalConfirmacao" @modal-fechou="() => modalCarregaAssinatura()">
				<button
					type="button"
					class="close"
					@click="
						revisar = true
						$refs.modalConfirmacao.modalHide()
					"
				>
					<span aria-hidden="true">&times;</span>
				</button>

				<h4 class="modal-title" v-if="!assinar && !editar">{{ _traducao('global', 'finalizarTracho').toUpperCase() }}</h4>
				<h4 class="modal-title" v-if="!assinar && editar">{{ _traducao('global', 'editarTrecho').toUpperCase() }}</h4>
				<h4 class="modal-title" v-if="assinar">ASSINAR TRECHO</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12 text-center text-info">
						<h3 v-if="!assinar && !editar">
							<i class="fa fa-fw fa-info-circle"></i> {{ _traducao('global', 'desejaFinalizarTrecho') }}<BR />
							<strong>{{ trecho.numero_diario }}</strong>
						</h3>
						<h3 v-if="!assinar && editar">
							<i class="fa fa-fw fa-info-circle"></i> {{ _traducao('global', 'desejaAtualizarTrecho') }} <BR />
							<strong>{{ trecho.numero_diario }}</strong>
						</h3>
						<h3 v-if="assinar">
							<i class="fa fa-fw fa-info-circle"></i> Deseja assinar esse trecho?<BR />
							<strong>{{ trecho.numero_diario }}</strong>
						</h3>
					</div>
				</div>

				<div class="row" style="margin-top: 10px">
					<div class="col-xs-6 text-center">
						<p style="margin-bottom: 0px">
							<strong>{{ _traducao('global', 'acionamento').toUpperCase() }}</strong>
						</p>
						<p>{{ form.acionamento }}</p>
					</div>
					<div class="col-xs-6 text-center">
						<p style="margin-bottom: 0px">
							<strong>{{ _traducao('global', 'decolagem').toUpperCase() }}</strong>
						</p>
						<p v-show="form.decolagem != null && form.decolagem != ''">{{ form.decolagem }}</p>
						<p v-show="form.decolagem == null || form.decolagem == ''">N/A</p>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-6 text-center">
						<p style="margin-bottom: 0px">
							<strong>{{ _traducao('global', 'pouso').toUpperCase() }}</strong>
						</p>
						<p v-show="form.pouso != null && form.pouso != ''">{{ form.pouso }}</p>
						<p v-show="form.pouso == null || form.pouso == ''">N/A</p>
					</div>
					<div class="col-xs-6 text-center">
						<p style="margin-bottom: 0px">
							<strong>{{ _traducao('global', 'corte').toUpperCase() }}</strong>
						</p>
						<p>{{ form.corte }}</p>
					</div>
				</div>

				<hr />

				<div class="row">
					<div class="col-xs-12 text-center">
						<p class="text-info">
							<strong>{{ _traducao('global', 'horimetro').toUpperCase() }}</strong>
						</p>
					</div>
					<div class="col-xs-6 text-center">
						<p style="margin-bottom: 0px">
							<strong>{{ _traducao('global', 'inicial').toUpperCase() }}</strong>
						</p>
						<p>{{ form.horimetro_inicial | horimetro }}</p>
					</div>
					<div class="col-xs-6 text-center">
						<p style="margin-bottom: 0px">
							<strong>{{ _traducao('global', 'final').toUpperCase() }}</strong>
						</p>
						<p>{{ form.horimetro_final | horimetro }}</p>
					</div>
				</div>

				<hr />

				<div class="row" v-if="editar && form.id_assinatura_piloto != ''">
					<div class="col-xs-12 text-center">
						<h3 class="text-danger"><i class="fa fa-fw fa-warning"></i>Será necessária uma nova assinatura do piloto.</h3>
					</div>
				</div>

				<div class="row" v-if="form.processa_horimetro">
					<div class="col-xs-12 text-center">
						<h3 class="text-danger">
							<i class="fa fa-fw fa-warning"></i>Você alterou o tempo de voo, com isso será necessário a assinatura do piloto para
							este trecho e todos os subsequentes.
						</h3>
					</div>
				</div>

				<div class="row" v-if="assinar">
					<div class="col-xs-12">
						<div class="checkbox pull-right">
							<label style="line-height: 20px">
								<input type="checkbox" v-model="cienteAssinatura" />ESTOU CIENTE QUANTO AS INFORMAÇÕES QUE TRATAM OS
								<a href="#" @click.prevent="clickExibeModalDiario('I', false)">INCISOS XIII A XVII</a> DO ART. 4º DA RESOLUÇÃO
								457.
							</label>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<button
							class="btn btn-default"
							type="button"
							@click="
								revisar = true
								$refs.modalConfirmacao.modalHide()
							"
						>
							{{ _traducao('global', 'revisar').toUpperCase() }}
						</button>

						<button v-if="!editar && !assinar" class="btn btn-success pull-right" type="button" @click="clickSalvar()">
							<i class="fa fa-fw fa-check"></i>{{ _traducao('global', 'finalizar').toUpperCase() }}
						</button>

						<button v-if="editar && !assinar" class="btn btn-success pull-right" type="button" @click="clickSalvar()">
							<i class="fa fa-fw fa-check"></i>{{ _traducao('global', 'atualizar').toUpperCase() }}
						</button>

						<button
							v-if="assinar"
							:disabled="!cienteAssinatura"
							class="btn btn-success pull-right"
							type="button"
							@click="clickSalvar()"
						>
							<i class="fa fa-fw fa-check"></i>{{ _traducao('global', 'assinarEFinalizar').toUpperCase() }}
						</button>
					</div>
				</div>
			</modal>

			<flModalAssinatura ref="assinatura" @assinado="(assinatura) => validaAssinatura(assinatura)" />
		</div>

		<modal ref="modalDiario">
			<button type="button" class="close" @click="$refs.modalDiario.modalHide()">
				<span aria-hidden="true">&times;</span>
			</button>

			<h4 class="modal-title" v-if="tipoDBModal == 'I'">INCISOS XIII A XVII DO ART. 4º DA RESOLUÇÃO 457</h4>

			<h4 class="modal-title" v-if="tipoDBModal == 'C'">DIÁRIO DE BORDO</h4>

			<hr style="margin-top: 6px" />
			<flPrintDiario name="diario" ref="diarioModal" :cabecalho="false" :voo="false" />

			<div class="row text-center" v-if="tipoDBModal == 'I'">
				<div class="col-xs-12">
					<button class="btn btn-info" @click="clickExibeModalDiario('C', true)">VER DIÁRIO DE BORDO COMPLETO</button>
				</div>
			</div>

			<div class="row text-center" v-if="tipoDBModal == 'C'">
				<div class="col-xs-12">
					<button class="btn btn-info" @click="clickExibeModalDiario('I', true)">
						VER INCISOS XIII A XVII DO ART. 4º DA RESOLUÇÃO 457
					</button>
				</div>
			</div>
		</modal>

		<!-- PRINT DA SOLICITACAO -->
		<div class="print">
			<div class="col-xs-12">
				<flPrintDiario name="diario" ref="printDiario" :cabecalho="false" :voo="false" />
			</div>
		</div>

		<div v-if="visualizar">
			<div class="container-fluid no-print">
				<!-- cabecalho -->
				<div class="fl-cabecalho" v-show="cabecalho">
					<div class="row">
						<div class="col-md-4 col-xs-12">
							<i class="icon icon-diario_bordo"></i>
							<h3>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h3>
							<h4>{{ _traducao('global', 'pilotoECopiloto').toUpperCase() }}</h4>
						</div>

						<div class="col-md-4 col-xs-12">
							<i class="icon icon-vizualizar icon-sub"></i>
							<h3>{{ _traducao('global', 'visualizar').toUpperCase() }}</h3>
							<h4>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h4>
						</div>

						<div class="col-md-4 col-xs-12">
							<button @click="voltaLista()" class="btn btn-default pull-right btn-lg" :title="_traducao('global', 'voltar')">
								<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
							</button>

							<button
								v-if="form.nome_arquivo == ''"
								class="btn btn-default pull-right btn-lg"
								:title="_traducao('global', 'imprimir')"
								style="margin-right: 20px"
								@click="clickPrintVisualizar()"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</button>

							<a
								v-if="form.nome_arquivo != ''"
								:href="form.nome_arquivo"
								target="_blank"
								class="btn btn-default pull-right btn-lg"
								style="margin-right: 20px"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</a>
						</div>
					</div>
				</div>
			</div>

			<!-- exibe o html caso não tenha pdf ainda -->
			<div class="col-xs-12">
				<ul v-if="form.nome_arquivo != ''" class="nav nav-tabs no-print" style="margin-top: 10px" role="tablist">
					<li :class="{active: tab == 'SISTEMA'}"><a href="#" @click.prevent="tab = 'SISTEMA'">SISTEMA</a></li>
					<li :class="{active: tab == 'PDF'}"><a href="#" @click.prevent="tab = 'PDF'">PDF</a></li>
				</ul>
				<!-- <a :href="form.nome_arquivo" download="iPhone User's Guide.PDF">click me</a> -->
				<flPrintDiario name="visualizar" v-show="tab == 'SISTEMA'" ref="printVisualizar" :cabecalho="false" :voo="voo" />

				<!-- exibe o pdf caso já tenha -->
				<embed
					type="application/pdf"
					:src="form.nome_arquivo"
					ref="pdfDocument"
					v-show="tab == 'PDF'"
					width="100%"
					:height="_height - 130"
				/>
			</div>
		</div>

		<!-- MODAL COM A ESCOLA DA AERONAVE A SER SUBISTITIDA -->
		<modal ref="modalAero" @modal-fechou="() => carregaDadosAero()">
			<div style="min-height: 400px">
				<button type="button" class="close" @click="$refs.modalAero.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaAeronave').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-md-1 col-xs-12 text-info">
						<i class="fa fa-fw fa-info-circle fa-3x" style="margin-top: 18px"></i>
					</div>
					<div class="col-md-10 col-xs-12 form-group">
						<h4 class="text-info" style="line-height: 30px">
							{{ _traducao('global', 'naoEncontramosSuaAero') }}
						</h4>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th>{{ _traducao('cadAeronave', 'prefixo') }}</th>
										<th>{{ _traducao('cadAeronave', 'codinome') }}</th>
										<th>{{ _traducao('cadAeronave', 'tipo') }}</th>
										<th>{{ _traducao('cadAeronave', 'modelo') }}</th>
									</tr>
								</thead>
								<tbody v-if="aerosImport.length > 0">
									<tr
										style="cursor: pointer"
										class="table-hover-tr"
										@click="clickSetaAero(item)"
										v-for="(item, idx) in aerosImport"
										:key="idx"
									>
										<td>{{ item._aero.prefixo }}</td>
										<td>{{ item._aero.codinome }}</td>
										<td>{{ item._aero.modelo }}</td>
										<td>
											<span v-show="item._aero.tipo == 'A'">{{ _traducao('cadAeronave', 'aviao') }}</span>
											<span v-show="item._aero.tipo == 'H'">{{ _traducao('cadAeronave', 'helicoptero') }}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA ESCOLHER O PASSAGEIRO -->
		<modal name="modal-ordem-escolha-passageiros">
			<div>
				<button type="button" class="close" @click="_escondeModal('modal-ordem-escolha-passageiros')">
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneOsPassageirosTrecho').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th colspan="10" style="background: #eee" class="text-center">PASSAGEIROS</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'nome') }}</th>
										<th>{{ _traducao('global', 'orgao') }}</th>
										<th>{{ _traducao('menuRGordemmissao', 'menuOMcargo') }}</th>
										<th>{{ _traducao('menuMatricula', 'cpf') }}</th>
										<th>{{ _traducao('global', 'telefone') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr
										class="table-hover-tr"
										style="cursor: pointer"
										@click="clickSelecionaPassageiro(index)"
										:class="{'bk-success': item.selecionado}"
										v-for="(item, index) in passageirosSelecao"
										:key="index"
									>
										<td>{{ item.nome | na }}</td>
										<td>{{ item.orgao | na }}</td>
										<td>{{ item.cargo | na }}</td>
										<td>{{ item.cpf | na }}</td>
										<td>
											{{ item.telefone | na
											}}<i v-if="item.selecionado" class="text-success pull-right fa fa-fw fa-check-circle"></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<hr />

				<div class="row">
					<div class="col-xs-12">
						<button class="btn btn-success pull-right" @click="clickImportaPassageiros()">
							<i class="fa fa-fw fa-check"></i> OK
						</button>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import $click from './mixins/click.js'
import $carrega from './mixins/carrega.js'
import $tabela from '../../../../../mixins/tabela.js'
import flPrintDiario from '../print/main.vue'
import flOrigemVoo from './origem-voo.vue'

export default {
	mixins: [$click, $carrega, $tabela],

	components: {
		flPrintDiario,
		flOrigemVoo
	},

	props: {
		visualizar: {
			type: Boolean,
			default: false,
			required: false
		},

		cabecalho: {
			type: Boolean,
			default: true,
			required: false
		},

		voo: {
			type: Boolean,
			default: true,
			required: false
		}
	},

	data() {
		return {
			tab: 'SISTEMA',

			tipoDBModal: 'I',

			revisar: false,
			mostraacionamentoUTC: false,
			decolagemUTC: false,
			pousoUTC: false,
			corteUTC: false,
			tipoPassageiro: '',
			loadUnidade: false,
			timeOut: '',
			timeOutModal: '',
			dataNascimento: null,
			simHorimetroManutencao: false,
			naoHorimetroManutencao: false,

			bases: [],
			tiposDeMissoes: [],
			descricoes: [],
			unidadesConservacao: [],
			contextos: [],
			orgaos: [],
			estados: [],
			rotaER: [],
			pilotos: [],
			aeronaves: [],
			subclassificacoes: [],
			mecanicos: [],
			load: true,
			//exibirTriuplacao: false,
			itemCopiar: '',

			tipo_planejada: '',

			cienteAssinatura: false,

			aerosImport: [],

			ciclo_nf: '',
			ciclo_nf: '',

			aeronave: {
				prefixo: '',
				codinome: '',
				categoria: ''
			},

			classificacoes: [],
			listaDivFilter: [],
			listaClasFilter: [],
			aeronave_import: '',

			podemSerPilotos: [],
			loadDe: false,
			loadPara: false,
			editar: false,

			ordem: '',
			despacho: '',
			cidadesDe: [],
			cidadesPara: [],
			passageirosSelecao: [],
			trecho: {},

			formPost: {},
			retornoWS: {},

			loadSub: false,
			assinar: false,

			form: {
				id: 0,
				tipo_voo: '',
				auto_localizado: 0,

				chave_validacao: '',
				descricao_ultima_inspecao: '',
				descricao_proxima_inspecao: '',

				ultima_intervencao: '',
				proxima_intervencao: '',
				horimetro_proxima: '',
				id_responsavel_retorno: '',
				nome_usuario_retorno: '',

				nome_usuario_inseriu: '',
				data_cadastro: '',
				arma_apreendida: 0,
				pessoa_salva: 0,
				pessoa_detida: 0,
				valor_recuperado: 0,
				//tempo_voo_celula: 0,
				voo_instrucao: '0',
				tempo_voo_motor: 0,
				finalizar_despacho: '',
				id_aeronave_import: '',
				nome_usuario_assinou: '',
				data_assinatura_piloto: '',
				nome_mecanico_assinou: '',
				nome_operador_assinou: '',
				data_assinatura_mecanico: '',
				data_assinatura_operador: '',
				voo: null,
				de: '',
				base: '',
				de_select: '',
				nome_estado_de: '',
				nome_cidade_de: '',
				unidade_combustivel: '',
				acionamento: '',
				corte: '',
				acionamento_utc: '',
				decolagem_utc: '',
				pouso_utc: '',
				corte_utc: '',
				ocorrencia: '0',
				ocorrencias: [],

				para: '',
				para_select: '',
				nome_estado_para: '',
				nome_cidade_para: '',

				houve_contexto: '',
				contexto_operativo: '',

				carga: '',
				descricao_carga: '',
				peso_carga: '',
				carga_liquida: '',

				decolagem: '',
				pouso: '',

				natureza_voo: '',
				numero_atividade: '',
				numero_bo: '',
				diario_fisico: '',
				numero_chamada: '',
				existe_unidade_conservacao: '',

				total_ciclo_torque: '',
				total_gancho: '',
				total_guincho: '',
				total_partidas: '',
				total_pousos: '',

				ovn: '',
				flir: '',
				ciclo_ng: '',
				ciclo_nf: '',
				numero_voo: '',
				tipo_voo_pagamento: '',

				nome_arquivo: '',

				finalizar_ordem: '',

				vfr_diurno: '',
				tempo_voo_piloto: '',
				tempo_voo_manutencao: '',
				adiciona_horimetro_manutencao: '',
				horimetro_manutencao: '',
				horimetro_manutencao_final: '',

				hora_vfr_noturno: '00:00',
				hora_vfr_diurno: '00:00',
				hora_ifr: '00:00',
				hora_navegacao: '00:00',

				vfr_noturno: '',
				ifr: '',
				navegacao: '',
				arquivo: '',
				total: '',

				horimetro_final: '',
				horimetro_inicial: '',

				combustivel: '',
				partidas: 1,
				pousos: 1,

				objetivo_alcancado: '',

				tipo_missao: '',
				tipo_classificacao: '',
				motores: [],
				observacao: '',
				descricao: '',

				classificacao: '',
				subclassificacao: '',
				// divisao:'',

				unidade_conservacao: [
					{
						obj: '',
						erro: ''
					}
				],
				base_origem: '',

				id_assinatura_piloto: '',

				coracao: 0,
				rim: 0,
				figado: 0,
				cornea: 0,
				esclero: 0,
				baco: 0,

				gancho: 0,
				guincho: 0,

				socorrido: 0,
				bambi: 0,
				brigadista: 0,

				tripulacao: [
					{
						id_usuario: '',
						erroUsuario: '',
						funcao: 'Piloto em Comando',
						anac: '',
						apresentacao: '',
						erroApresentacao: '',
						codigo_ovn: '',
						erroOVN: '',
						trigrama: ''
					}
				],

				discrepancia: [],

				passageiro: [],

				orgao: [],

				processa_horimetro: false,
				tempo_motor_diario: '',
				tempo_piloto_diario: ''
			},
			exibir: true,
			listaSubFilter: [],
			controlaLista: false,

			erro: {
				diurnoNortuno: '',
				tempo_voo_piloto: '',
				id_ordem_trecho: '',
				tempo_voo_motor: '',
				numero_atividade: '',
				unidade_combustivel: '',
				numero_bo: '',
				base: '',
				acionamento: '',
				instrutor_voo: '',
				corte: '',
				existe_unidade_conservacao: '',

				objetivo_alcancado: '',
				tipo_voo_pagamento: '',
				adiciona_horimetro_manutencao: '',
				tempo_voo_manutencao: '',

				numero_chamada: '',
				diario_fisico: '',
				finalizar_ordem: '',

				observacao: '',

				classificacao: '',
				subclassificacao: '',
				// divisao:'',

				descricao: '',

				houve_contexto: '',
				contexto_operativo: '',

				finalizar_despacho: '',

				orgao: '',
				de: '',
				nome_estado_de: '',
				nome_cidade_de: '',

				para: '',
				nome_estado_para: '',
				nome_cidade_para: '',

				decolagem: '',
				pouso: '',

				tipo_missao: '',
				tipo_classificacao: '',

				ovn: '',
				flir: '',

				pax: '',

				carga: '',
				descricao_carga: '',
				peso_carga: '',
				carga_liquida: '',

				vfr_diurno: '',
				vfr_noturno: '',
				ifr: '',
				navegacao: '',
				total: '',
				ciclo_ng: '',
				ciclo_nf: '',
				numero_voo: '',
				horimetro_final: '',
				horimetro_inicial: '',
				combustivel: '',
				partidas: '',
				pousos: ''
			}
		}
	},

	computed: {
		tempoVooMotor() {
			if (this.form.decolagem == '' || this.form.pouso == '') {
				return ''
			} else if (this.form.decolagem != this.form.pouso) {
				var dec = moment(this.form.decolagem, $sessao.getDateFormat() + ' HH:mm').locale(this._getLangDp)
				var pouso = moment(this.form.pouso, $sessao.getDateFormat() + ' HH:mm').locale(this._getLangDp)

				var diff = pouso.diff(dec)
				var duration = moment.duration(diff)

				var $hours = duration.hours()
				var $days = duration.days()
				var $minutes = duration.minutes()

				var hora = ''
				var minuto = ''

				if (!_.isNil($hours)) {
					if (Number($hours) < 10) {
						hora = '0' + $hours
					} else {
						hora = $hours
					}
				} else {
					hora = '00'
				}

				if (!_.isNil($minutes)) {
					if (Number($minutes) < 10) {
						minuto = '0' + $minutes
					} else {
						minuto = $minutes
					}
				} else {
					minuto = '00'
				}

				var h = Number(hora) + $days * 24
				return (h < 10 ? '0' + h : h) + ':' + minuto
			} else {
				return '00:00'
			}
		},

		_pilotos() {
			return this.pilotos.map((item) => {
				item.descricao = item.trigrama + ' - ' + item.nome
				return item
			})
		},

		_pilotos_mecanicos() {
			let pilotos = this.pilotos.map((item) => {
				item.descricao = item.trigrama + ' - ' + item.nome
				return item
			})

			let mecanicos = this.mecanicos.map((item) => {
				item.descricao = item.trigrama + ' - ' + item.nome
				return item
			})

			return _.concat(pilotos, mecanicos)
		},

		tempoVooPiloto() {
			if (this.form.acionamento == '' || this.form.corte == '') {
				return ''
			} else if (this.form.acionamento != this.form.corte) {
				var dec = moment(this.form.acionamento, $sessao.getDateFormat() + ' HH:mm').locale(this._getLangDp)
				var pouso = moment(this.form.corte, $sessao.getDateFormat() + ' HH:mm').locale(this._getLangDp)

				var diff = pouso.diff(dec)
				var duration = moment.duration(diff)

				var $hours = duration.hours()
				var $days = duration.days()
				var $minutes = duration.minutes()

				var hora = ''
				var minuto = ''

				if (!_.isNil($hours)) {
					if (Number($hours) < 10) {
						hora = '0' + $hours
					} else {
						hora = $hours
					}
				} else {
					hora = '00'
				}

				if (!_.isNil($minutes)) {
					if (Number($minutes) < 10) {
						minuto = '0' + $minutes
					} else {
						minuto = $minutes
					}
				} else {
					minuto = '00'
				}

				var h = Number(hora) + $days * 24
				return (h < 10 ? '0' + h : h) + ':' + minuto
			} else {
				return '00:00'
			}
		},

		exibeForm() {
			if (this.form.tipo_voo != '') {
				return true
			} else if (this.edicao) {
				return true
			}

			return false
		},

		edicao() {
			return this.form.id == 0 ? false : true
		},

		maxDate() {
			return new moment().format($sessao.getDateFormat() + ' HH:mm')
		}
	},

	watch: {
		'form.tipo_missao': function (val, oldVal) {
			if (val != oldVal) {
				if (val != null) {
					this.listaClasFilter = _.filter(this.classificacoes, (o) => {
						return o.id_tipo_missao == val.id
					})
					this.form.tipo_classificacao = ''
					if (this.listaClasFilter == '') {
						this.form.classificacao = ''
						this.form.subclassificacao = ''
						// this.form.divisao = ''
					} else {
						this.recebendoDados == false ? (this.form.classificacao = '') : (this.recebendoDados = false)
					}
				} else {
					this.listaClasFilter = this.classificacoes
				}
			}
		},

		'form.classificacao': function (val, oldVal) {
			if (val != oldVal) {
				if (val != null) {
					this.listaSubFilter = _.filter(this.subclassificacoes, (o) => {
						return o.id_classificacao == val.id
					})

					if (this.listaSubFilter == '') {
						this.exibir = false
						this.form.subclassificacao = ''
						// this.form.divisao = ''
					} else {
						this.form.subclassificacao = ''
						// this.form.divisao = ''
						this.exibir = true
						this.controlaLista == true ? (this.form.subclassificacao = '') : (this.controlaLista = true)
					}
				} else {
					this.listaSubFilter = this.subclassificacoes
				}
			}
		},

		// 'form.subclassificacao': function(val, oldVal){
		// 	console.log('sub classificacao watcher', this.form.subclassificacao)
		// 	if(val != oldVal){
		// 		if(val != null){
		// 			this.listaDivFilter = _.filter(this.divisoes, o => {return o.id_subclassificacao === val.id})
		// 			// if(this.listaDivFilter == ''){
		// 				this.form.divisao = ''
		// 			// }
		// 		}else{
		// 			this.form.divisao = ''
		// 			// this.listaDivFilter = this.divisoes
		// 		}
		// 	}
		// 	console.log('divfilter', this.listaDivFilter)
		// },

		'form.de_select': function (val, oldVal) {
			if (val != null) {
				if (val.sigla == 'ZZZZ') {
					this.form.de = val.sigla
					if (!this.edicao) {
						this.nome_estado_de = ''
						this.nome_cidade_de = ''
					}
				} else {
					this.form.de = val.sigla
					this.form.nome_cidade_de = val.cidade
					this.form.nome_estado_de = val.uf
				}
			} else {
				this.form.de = ''
			}
		},

		'form.para_select': function (val, oldVal) {
			if (val != null) {
				if (val.sigla == 'ZZZZ') {
					this.form.para = val.sigla
					if (!this.edicao) {
						this.form.nome_estado_para = ''
						this.form.nome_cidade_para = ''
					}
				} else {
					this.form.para = val.sigla
					this.form.nome_cidade_para = val.cidade
					this.form.nome_estado_para = val.uf
				}
			} else {
				this.form.para = ''
			}
		},

		'form.horimetro_inicial': function (val, oldVal) {
			if (val != oldVal) {
				this.calculaTotal()
			}
		},

		'form.tipo_voo_pagamento': function (val, oldVal) {
			if (val != oldVal) {
				// this.form.adiciona_horimetro_manutencao = ''
				this.form.tempo_voo_manutencao = ''
				if (this.simHorimetroManutencao) {
					this.form.tempo_voo_motor = Number(this.form.tempo_voo_motor) - 0.1
					this.form.horimetro_manutencao_final = Number(this.form.horimetro_manutencao_final) - 0.1
					this.simHorimetroManutencao = false
				}
			}
		}
	},

	beforeDestroy() {
		this.limpaTimeOuts()
	},

	mounted() {
		this.carregaDados()
		this.clickAddOrgao()
	},

	methods: {
		alteraHorimetroManutencao(tipo) {
			if (tipo == '+') {
				if (!this.simHorimetroManutencao) {
					this.form.tempo_voo_motor = Number(this.form.tempo_voo_motor) + 0.1
					this.form.horimetro_manutencao_final = Number(this.form.horimetro_manutencao_final) + 0.1
					this.simHorimetroManutencao = true
					this.naoHorimetroManutencao = false
				}
			}

			if (tipo == '-') {
				if (!this.naoHorimetroManutencao) {
					if (this.simHorimetroManutencao) {
						this.form.tempo_voo_motor = Number(this.form.tempo_voo_motor) - 0.1
						this.form.horimetro_manutencao_final = Number(this.form.horimetro_manutencao_final) - 0.1
						this.simHorimetroManutencao = false
					}
				}
			}
		},

		preencherDiario(data) {
			// se não tiver carregando chama a função que verifica se todas as listas foram carregadas
			if (!this.load) {
				this.editar = false
				this.form.acionamento = data.trecho._dataAcionamento
				this.form.corte = data.trecho._dataCorte

				if (data.trecho.gerado_pelo_service) {
					this.form.decolagem = this._SQLDateToDateTime(data.trecho.decolagem, $sessao.getDateFormat() + ' HH:MM')
					this.form.pouso = this._SQLDateToDateTime(data.trecho.pouso, $sessao.getDateFormat() + ' HH:MM')
				}

				// seta true pra atualizar as datas
				this.mostraacionamentoUTC = true
				this.decolagemUTC = true
				this.pousoUTC = true
				this.corteUTC = true
				this.assinar = data.assinar
				this.aeronave = data.aero
				console.log('aeronave', this.aeronave)
				this.trecho = data.trecho

				this.carregaHorimetro()
				this.carregaDisponibilidade()

				// carrega os usuários pilotos
				this.carregaUsuariosTripulacao('Piloto em Comando', 0, true, false)

				this.iniciaVerificacaoFechamento()

				if (data.trechoCopiar != null) {
					this.itemCopiar = data.trechoCopiar
					this.getDadosEdicao(data.trechoCopiar, true) // false pra copiar
				}

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
			} else {
				bus.$emit('load-in', {text: 'Carregando listas'})
				this.carregando(data, 'preencherDiario') // função que verivica se todas as listas foram carregadas
			}
		},

		carregando(data, funcao) {
			// seta um timeout de 1 segundo pra ficar verificando se todas as listas foram carregadas
			setTimeout(() => {
				if (
					this.bases.length > 0 && //ok
					this.tiposDeMissoes.length > 0 &&
					this.descricoes.length > 0 &&
					this.contextos.length > 0 &&
					this.orgaos.length > 0 &&
					this.estados.length > 0 && //ok
					this.rotaER.length > 0 && //ok
					this.pilotos.length > 0 &&
					this.aeronaves.length > 0 &&
					this.subclassificacoes.length > 0 && //ok
					this.mecanicos.length > 0
				) {
					console.log('carregando if')
					this.load = false
					this[funcao](data) // caso sim, chama a função
				} else {
					this.carregando(data, funcao)
				}
			}, 1000)
		},

		editarDiarioDeBordo(data) {
			if (!this.load) {
				this.aeronave = data.aero
				this.trecho = data.trecho
				this.form.acionamento = data.trecho._dataAcionamento
				this.form.corte = data.trecho._dataCorte
				this.editar = true
				this.assinar = data.assinar

				this.getDadosEdicao(this.trecho, false) // false pra copiar

				if (this.visualizar) {
					bus.$emit('load-in', {text: this._traducao('global', 'carregandoDiario')})
				} else {
					this.iniciaVerificacaoFechamento()
				}
			} else {
				bus.$emit('load-in', {text: 'Carregando listas'})
				this.carregando(data, 'editarDiarioDeBordo')
			}
		},

		carregaHistorico(data) {
			if (!this.load) {
				this.aeronave = data.aeronave
				this.trecho = data.trecho
				this.form.acionamento = this._SQLDateToDateTime(data.trecho.acionamento, $sessao.getDateFormat() + ' HH:MM')
				this.form.corte = this._SQLDateToDateTime(data.trecho.corte, $sessao.getDateFormat() + ' HH:MM')
				this.editar = true
				this.assinar = false
				this.carregaDadosEdicao(data.trecho, false)
			} else {
				bus.$emit('load-in', {text: 'Carregando listas'})
				this.carregando(data, 'carregaHistorico')
			}
		},

		carregaDisponibilidade() {
			this._httpGet('Disponibilidade/get_ultima/' + this.aeronave.id, (retorno) => {
				console.log('disponibilidade', retorno)
				if (retorno._status && retorno._request) {
					this.form.ultima_intervencao = retorno.lista.data_ultima
					this.form.proxima_intervencao = retorno.lista.data_proxima
					this.form.horimetro_proxima = retorno.lista.horimetro_proxima
					this.form.id_responsavel_retorno = retorno.lista.id_usuario_responsavel
					this.form.nome_usuario_retorno = retorno.lista.nome_usuario_responsavel
					this.form.descricao_ultima_inspecao = retorno.lista.descricao_ultima
					this.form.descricao_proxima_inspecao = retorno.lista.descricao
				}
			})
		},

		despachoSelecionado(despacho) {
			this.form.tipo_voo = despacho.tipo

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			// CARREGA O DESPACHO PARA A EDICAO
			this._httpGet('cta-maranhao/Despacho_emergencial/get/' + despacho.id, (retorno) => {
				console.log(retorno)
				if (retorno._request && retorno._status) {
					bus.$emit('load-out')

					this.despacho = retorno.lista
					this.form.numero_bo = retorno.lista.reds
					this.form.numero_chamada = retorno.lista.chamada
					this.form.numero_atividade = retorno.lista.atividade
					this.form.observacao = retorno.lista.historico

					this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
						return o.id == retorno.lista.id_tipo_missao
					})
					this.$nextTick(() => {
						this.form.tipo_classificacao = retorno.tipo_classificacao // == null ? '' : dados.tipo_classificacao
					})
					// classificacao
					this.form.classificacao = _.find(this.classificacoes, (o) => {
						return o.id == despacho.id_classificacao
					})
					//divisao
					this.$nextTick(() => {
						this.form.subclassificacao = _.find(this.subclassificacoes, (o) => {
							return o.id == retorno.lista.id_subclassificacao
						})
						// setTimeout(() => {
						// 	this.form.divisao = _.find(this.divisoes, o => {return o.id == retorno.lista.id_subclassificacao_divisao})
						// 	if(_.isNil(this.form.divisao)){
						// 		this.form.divisao = ''
						// 	}
						// }, 400)
					})

					// se não tiver editando importa os dados
					if (!this.edicao) {
						// se existir ordem, carrega os dados da ordem, tripulação, passageiros e orgão apoiados
						if (despacho.id_ordem_missao != null) {
							bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

							// CARREGA O DESPACHO PARA A EDICAO
							this._httpGet('cta-maranhao/Ordem_missao/editar/' + despacho.id_ordem_missao, (retorno) => {
								if (retorno._request) {
									bus.$emit('load-out')
									this.carregaCamposOrdem(retorno, false)
								}
							})
						} else {
							// caso não tenha ordem, importa os dados do despacho

							retorno.lista.aeronave = retorno.lista.aeronave.map((item) => {
								item._aero = _.find(this.aeronaves, (o) => {
									return o.id == item.id_aeronave
								})

								return item
							})

							var aero = _.find(retorno.lista.aeronave, (o) => {
								return o.id_aeronave == this.aeronave.id
							})
							this.form.houve_contexto = this.validaNull(despacho.houve_contexto)

							if (_.isNil(aero)) {
								this.aerosImport = retorno.lista.aeronave
								this.$refs.modalAero.modalShow(50)
							} else {
								this.aeronave_import = aero
								this.form.base = aero.base
								this.carregaDadosAero()
							}

							this.form.voo_instrucao = '0'

							if (this.form.houve_contexto != '0') {
								for (var i in this.contextos) {
									if (this.contextos[i].id == despacho.id_contexto_operativo) {
										this.form.contexto_operativo = this.contextos[i]
									}
								}
							}
						}
					}
				}
			})
		},

		setaAcionamento(val) {
			this.form.acionamento = val

			if (val != '') {
				if (this.mostraacionamentoUTC) {
					this.converteDataUTC(this.form.acionamento).then((res) => {
						this.form.acionamento_utc = res
						this.mostraacionamentoUTC = true
						this.$forceUpdate()
					})
				} else {
					this.mostraacionamentoUTC = true
				}

				this.calculaTempoDeVooPiloto()
				// this.calculaTempoManutencao()
				this.calculaTotal()
			}
		},

		setaDecolagem(val) {
			this.form.decolagem = val

			if (val != '') {
				if (this.decolagemUTC) {
					this.converteDataUTC(this.form.decolagem).then((res) => {
						this.form.decolagem_utc = res
						this.decolagemUTC = true
						this.$forceUpdate()
					})
				} else {
					this.decolagemUTC = true
				}

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			} else {
				this.form.decolagem_utc = ''
				this.form.tempo_voo_motor = 0
			}
		},

		setaPouso(val) {
			this.form.pouso = val

			if (val != '') {
				if (this.pousoUTC) {
					this.converteDataUTC(this.form.pouso).then((res) => {
						this.form.pouso_utc = res
						this.pousoUTC = true
						this.$forceUpdate()
					})
				} else {
					this.pousoUTC = true
				}

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			} else {
				this.form.pouso_utc = ''
				this.form.tempo_voo_motor = 0
			}
		},

		setaCorte(val) {
			this.form.corte = val
			if (val != '') {
				if (this.corteUTC) {
					this.calculaTempoDeVooPiloto()
					this.converteDataUTC(this.form.corte).then((res) => {
						this.form.corte_utc = res
						this.corteUTC = true
						this.$forceUpdate()
					})
					this.calculaTempoVooOrgao()
				} else {
					this.corteUTC = true
				}

				this.calculaTempoDeVooPiloto()
				// this.calculaTempoManutencao()
				this.calculaTotal()
			}
		},

		//recebe data utc
		converteDataUTC(data) {
			return new Promise((resolve) => {
				var dataRetorno
				data = this._dateTimeToDateSQL(data, $sessao.getDateFormat() + ' HH:MM:SS')
				data = data + ':00'
				//////console.log(data)

				var dataEnvio = {
					data: data
				}
				this.mostraUTC = true
				// return data
				this._httpPost('Servico/converte_utc', dataEnvio, (resposta) => {
					dataRetorno = this._SQLDateToDateTime(resposta['data'], $sessao.getDateFormat() + ' HH:MM')
					resolve(dataRetorno)
				})
			})
		},

		calculaIdade(ano_aniversario, mes_aniversario, dia_aniversario) {
			var d = new Date(),
				ano_atual = d.getFullYear(),
				mes_atual = d.getMonth() + 1,
				dia_atual = d.getDate(),
				ano_aniversario = +ano_aniversario,
				mes_aniversario = +mes_aniversario,
				dia_aniversario = +dia_aniversario,
				idade = ano_atual - ano_aniversario

			if (mes_atual < mes_aniversario || (mes_atual == mes_aniversario && dia_atual < dia_aniversario)) {
				idade--
			}

			return idade < 0 ? 0 : idade
		},

		alteraIdade(dataNascimento) {
			var dia = dataNascimento.substring(0, 2)
			var mes = dataNascimento.substring(3, 5)
			var ano = dataNascimento.substring(6, 10)
			var idade = this.calculaIdade(ano, mes, dia)
			//////console.log(idade)
			if (dataNascimento != '') {
				this.form.passageiro = this.form.passageiro.map((item) => {
					if (item.data_nascimento == dataNascimento) {
						item.idade_aparente = idade
					}
					return item
				})
			}
		},

		iniciaVerificacaoFechamento() {
			this.limpaTimeOuts()
			this.timeOut = setTimeout(() => {
				this._exibeModal('modal-ordem-tempo-expirado', 60)
			}, 600000)
			//this.timeOut = setTimeout(() => { this._exibeModal('modal-ordem-tempo-expirado', 60)}, 4000);
			this.timeOutModal = setTimeout(() => {
				this.voltaLista()
			}, 660000)
			//this.timeOut = setTimeout(() => { this.voltaLista() },4000);
		},

		clickPrintVisualizar() {
			this._print()
		},

		clickPrint() {
			this.$refs.printDiario.carregaDados({
				data: this.form,
				aero: this.aeronave,
				pilotos: this._pilotos_mecanicos,
				trecho: this.trecho
			})

			if (this.despacho != '' && this.form.nome_arquivo == '') {
				this.$refs.printDiario.carregaDespacho(this.despacho)
			}

			this.$nextTick(() => {
				window.print()
			})
		},

		getDadosEdicao(trecho, copiar) {
			if (copiar) {
				bus.$emit('load-in', {text: this._traducao('global', 'copiandoDiario')})
			} else {
				bus.$emit('load-in', {text: this._traducao('global', 'carregandoDiario')})
			}

			this._httpGet('cta-maranhao/Relatorio_voo_trecho/get/' + trecho.id, (response) => {
				console.log('edicao', response)
				bus.$emit('load-out')
				if (response._request) {
					if(copiar)
					{
						delete response.lista.trecho_motor
					}
					this.carregaDadosEdicao(response.lista, copiar)
				}
			})
		},

		carregaDadosEdicao(data, copiar) {
			console.log('retorno carrega dados edicao', data)

			
			this.form.id_aeronave_import = data.id_aeronave_import == null ? '' : data.id_aeronave_import
			this.form.tipo_voo = data.origem

			// carrega o despacho caso tenha
			if (data.id_despacho_emergencial != null) {
				this._httpGet('cta-maranhao/Despacho_emergencial/get/' + data.id_despacho_emergencial, (retorno) => {
					bus.$emit('load-out')
					console.log(retorno)
					if (retorno._request) {
						this.despacho = retorno.lista

						if (this.visualizar) {
							this.$refs.printVisualizar.carregaDespacho(this.despacho)
						}
					}
				})
			}

			this.form.clico_ng = data.clico_ng == null ? '' : data.clico_ng
			this.form.clico_nf = data.clico_nf == null ? '' : data.clico_nf
			this.form.total_ciclo_torque = data.total_ciclo_torque == null ? '' : data.total_ciclo_torque
			this.form.total_gancho = data.total_gancho == null ? '' : data.total_gancho
			this.form.total_guincho = data.total_guincho == null ? '' : data.total_guincho
			this.form.total_partidas = data.total_partidas == null ? '' : data.total_partidas
			this.form.total_pousos = data.total_pousos == null ? '' : data.total_pousos
			this.form.existe_unidade_conservacao = data.existe_unidade_conservacao

			if (_.isNil(data.motor)) {
				this.form.motores = []
			} else {
				this.form.motores = data.motor
			}

			// se tiver editando
			if (!copiar) {
				this.form.tempo_motor_diario = data.tempo_voo_motor
				this.form.tempo_piloto_diario = data.tempo_hora_piloto

				this.form.id_assinatura_piloto = data.id_assinatura_piloto == null ? '' : data.id_assinatura_piloto
				this.form.arquivo = data.arquivo == null ? '' : data.arquivo

				this.form.nome_usuario_assinou = data.nome_usuario_assinou == null ? '' : data.nome_usuario_assinou
				this.form.nome_mecanico_assinou = data.nome_mecanico_assinou == null ? '' : data.nome_mecanico_assinou
				this.form.nome_operador_assinou = data.nome_operador_assinou == null ? '' : data.nome_operador_assinou

				this.form.data_assinatura_piloto = data.data_assinatura_piloto == null ? '' : data.data_assinatura_piloto
				this.form.data_assinatura_mecanico = data.data_assinatura_mecanico == null ? '' : data.data_assinatura_mecanico
				this.form.data_assinatura_operador = data.data_assinatura_operador == null ? '' : data.data_assinatura_operador
				this.form.nome_arquivo = data.nome_arquivo == null ? '' : data.nome_arquivo

				this.form.id = data.id
				this.form.finalizar_ordem = data.finalizar_ordem
				this.form.id_ordem = data.id_ordem_missao
				this.form.id_despacho = data.id_despacho_emergencial
				this.form.voo_instrucao = data.voo_instrucao
				this.form.finalizar_despacho = data.finalizar_despacho
				this.form.hora_vfr_diurno = data.hora_vfr_diurno == null ? '00:00' : data.hora_vfr_diurno
				this.form.hora_vfr_noturno = data.hora_vfr_noturno == null ? '00:00' : data.hora_vfr_noturno
				this.form.hora_ifr = data.hora_ifr == null ? '00:00' : data.hora_ifr
				this.form.hora_navegacao = data.hora_navegacao == null ? '00:00' : data.hora_navegacao
				this.form.ciclo_ng = this.toNumber2Casa(data.ciclo_ng)
				this.form.ciclo_nf = this.toNumber2Casa(data.ciclo_nf)
				this.form.nome_usuario_inseriu = data.nome_usuario_inseriu
				this.form.data_cadastro = data.data_cadastro

				this.form.ultima_intervencao = data.ultima_intervencao
				this.form.proxima_intervencao = data.proxima_intervencao
				this.form.horimetro_proxima = data.horimetro_proxima
				this.form.descricao_ultima_inspecao = data.descricao_ultima_inspecao == null ? '' : data.descricao_ultima_inspecao
				this.form.descricao_proxima_inspecao = data.descricao_proxima_inspecao == null ? '' : data.descricao_proxima_inspecao
				this.form.id_responsavel_retorno = data.id_responsavel_retorno
				this.form.nome_usuario_retorno = data.nome_usuario_retorno
				this.form.objetivo_alcancado = data.objetivo_alcancado == null ? '' : data.objetivo_alcancado
				this.form.tipo_voo_pagamento = data.tipo_voo_pagamento == null ? '' : data.tipo_voo_pagamento
				this.form.adiciona_horimetro_manutencao =
					data.adiciona_horimetro_manutencao == null ? '' : data.adiciona_horimetro_manutencao
				this.form.tempo_voo_manutencao = data.tempo_voo_manutencao == null ? '' : data.tempo_voo_manutencao
				this.form.horimetro_manutencao =
					data.total_tempo_voo_manutencao == null ? '' : Number(Number(data.total_tempo_voo_manutencao).toFixed(1))
				this.form.horimetro_manutencao_final =
					data.horimetro_final_manutencao == null ? '' : Number(Number(data.horimetro_final_manutencao).toFixed(1))

				if (this.form.adiciona_horimetro_manutencao == '1') {
					this.simHorimetroManutencao = true
					this.naoHorimetroManutencao = false
				} else {
					this.naoHorimetroManutencao = true
				}

				// PMSP
				this.form.valor_recuperado = this.toNumber2Casa(data.valor_recuperado)
				this.form.auto_localizado = Number(data.auto_localizado)
				this.form.arma_apreendida = Number(data.arma_apreendida)
				this.form.pessoa_salva = Number(data.pessoa_salva)
				this.form.pessoa_detida = Number(data.pessoa_detida)
				// FIM PMSP

				this.form.numero_voo = Number(data.numero_voo)
				this.form.decolagem = this._SQLDateToDateTime(data.decolagem, $sessao.getDateFormat() + ' HH:MM')
				this.setaDecolagem(this.form.decolagem)
				this.form.pouso = this._SQLDateToDateTime(data.pouso, $sessao.getDateFormat() + ' HH:MM')
				this.setaPouso(this.form.pouso)

				

				if (data.pouso_utc != null) {
					this.form.pouso_utc = this._SQLDateToDateTime(data.pouso_utc, $sessao.getDateFormat() + ' HH:MM')
				} else {
					this.form.pouso_utc = ''
				}

				if (data.decolagem_utc != null) {
					this.form.decolagem_utc = this._SQLDateToDateTime(data.decolagem_utc, $sessao.getDateFormat() + ' HH:MM')
				} else {
					this.form.decolagem_utc = ''
				}

				if (data.corte_utc != null) {
					this.form.corte_utc = this._SQLDateToDateTime(data.corte_utc, $sessao.getDateFormat() + ' HH:MM')
				} else {
					this.form.corte_utc = ''
				}

				if (data.acionamento_utc != null) {
					this.form.acionamento_utc = this._SQLDateToDateTime(data.acionamento_utc, $sessao.getDateFormat() + ' HH:MM')
				} else {
					this.form.acionamento_utc = ''
				}

				this.form.horimetro_inicial = this.toNumber1Casa(data.horimetro_partida)
				this.form.horimetro_final = this.toNumber1Casa(data.horimetro_corte)

				this.form.combustivel = Number(data.combustivel).toFixed(0)
				this.form.partidas = Number(data.partidas)
				this.form.pousos = Number(data.pousos)
				this.form.guincho = Number(data.guincho)
				this.form.unidade_combustivel = data.unidade_combustivel
				this.form.flir = data.flir
				this.form.ovn = data.ovn
				this.form.voo = data.voo

				if (data.discrepancia.length > 0) {
					this.form.discrepancia = data.discrepancia.map((item) => {
						item.id_usuario = item.id_usuario_discrepancia
						item.descricao = item.descricao_discrepancia
						var pilot = _.find(this._pilotos_mecanicos, (o) => {
							return o.id_usuario == item.id_usuario_discrepancia
						})

						item.trigrama = pilot.trigrama
						item.anac = pilot.codigo_anac
						item.nome = pilot.nome
						item.erroUsuario = ''
						item.erroDescricao = ''
						item.erroTipo = ''
						return item
					})
				}
			}

			if (data.ocorrencias.length > 0) {
				this.form.ocorrencias = data.ocorrencias.map((item) => {
					item.erro_data = ''
					item.erro_local = ''
					item.erro_codigo_classificacao = ''
					item.erro_qualificacao_civil = ''
					item.erro_descricao_fatos = ''
					item.data = this._SQLDateToDateTime(item.data, $sessao.getDateFormat() + ' HH:MM')

					return item
				})
			}

			this.form.de = data.de
			this.form.de_select = _.find(this.rotaER, (o) => {
				return o.sigla == data.de
			})
			this.form.nome_cidade_de = data.cidade_inicio_missao
			this.form.nome_estado_de = data.estado_inicio_missao
			this.blurCarregaCidades('de', false)

			this.form.para = data.para
			this.form.para_select = _.find(this.rotaER, (o) => {
				return o.sigla == data.para
			})
			this.form.nome_cidade_para = data.cidade_termino_missao
			this.form.nome_estado_para = data.estado_termino_missao
			this.blurCarregaCidades('para', false)

			// pega os dados do piloto
			this.form.tripulacao[0].id_usuario = data.tripulacao[0].id_usuario
			this.form.tripulacao[0].erroUsuario = ''
			this.form.tripulacao[0].apresentacao = this._SQLDateToDateTime(
				data.tripulacao[0].apresentacao,
				$sessao.getDateFormat() + ' HH:MM'
			)
			this.form.tripulacao[0].erroApresentacao = ''
			this.form.tripulacao[0].codigo_ovn = data.tripulacao[0].codigo_ovn
			this.form.tripulacao[0].erroOVN = ''
			this.form.tripulacao[0].usuarios = []

			this.carregaUsuariosTripulacao(data.tripulacao[0].funcao, 0, false, true)

			this.form.passageiro = data.passageiro.map((it) => {
				it._tipo = it.tipo
				it.nomeErro = ''
				it.orgaoErro = ''
				it.cargoErro = ''
				it.cpfErro = ''
				it.telefoneErro = ''
				it.sexoErro = ''

				if (!_.isNil(it.data_nascimento)) {
					it.data_nascimento = this._SQLDateToDate(it.data_nascimento, $sessao.getDateFormat())
				}
				return it
			})

			for (var i in data.tripulacao) {
				if (data.tripulacao[i].funcao != null) {
					if (Number(data.tripulacao[i].id_usuario) != 0 && data.tripulacao[i].funcao != 'Piloto em Comando') {
						this.form.tripulacao.push({
							id_usuario: data.tripulacao[i].id_usuario,
							erroUsuario: '',
							funcao: data.tripulacao[i].funcao,
							anac: '',
							apresentacao: this._SQLDateToDateTime(data.tripulacao[i].apresentacao, $sessao.getDateFormat() + ' HH:MM'),
							erroApresentacao: '',
							codigo_ovn: data.tripulacao[i].codigo_ovn,
							usuarios: [],
							nome: '',
							trigrama: '',
							erroFuncao: '',
							erroOVN: ''
						})

						this.carregaUsuariosTripulacao(data.tripulacao[i].funcao, i, false, true)
					}
				}
			}

			this.form.base = data.base
			this.form.numero_bo = data.numero_bo
			this.form.diario_fisico = data.diario_fisico
			this.form.numero_chamada = data.numero_chamado
			this.form.numero_atividade = data.numero_atividade

			

			// para o histórico, antes tinha so a descrição, depois criamos uma tabela, então para não dar pau no histórico
			// verifico se o id e null, se for carrega pela descrição, se tiver id, carrega pelo id
			// if(_.isNil(data.id_tipo_missao)){
			// 	this.form.tipo_missao = _.find(this.tiposDeMissoes, o => {return o.descricao == data.descricao_tipo_missao})
			// } else {
			// 	this.form.tipo_missao = _.find(this.tiposDeMissoes, o => {return o.id == data.id_tipo_missao})
			// }

			this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
				return o.id == data.id_tipo_missao
			})
			this.$nextTick(() => {
				this.form.tipo_classificacao = data.tipo_classificacao // == null ? '' : dados.tipo_classificacao
			})
			// this.form.tipo_classificacao = this.form.tipo_classificacao = data.tipo_classificacao == null ? '' : data.tipo_classificacao
			// this.form.tipo_missao = _.find(this.tiposDeMissoes, o => {return o.id == data.id_tipo_missao})
			// this.form.descricao = data.descricao_missao

			var clas = _.find(this.classificacoes, (o) => {
				return o.id == data.id_classificacao
			})
			this.form.classificacao = clas

			this.$nextTick(() => {
				this.form.subclassificacao = _.find(this.subclassificacoes, (o) => {
					return o.id == data.id_subclassificacao
				})
				// setTimeout(() => {
				// 	this.form.divisao = _.find(this.divisoes, o => {return o.id == data.id_subclassificacao_divisao})
				// 	if(_.isNil(this.form.divisao)){
				// 		this.form.divisao = ''
				// 	}
				// }, 400)
			})
			this.form.houve_contexto = this.validaNull(data.houve_contexto)

			if (this.form.houve_contexto != null) {
				for (var i in this.contextos) {
					if (this.contextos[i].id == data.id_contexto_operativo) {
						this.form.contexto_operativo = this.contextos[i]
					}
				}
			}

			// orgaos recebidos
			this.form.orgao = []
			_.forEach(data.orgao, (org) => {
				var orgao_apoiado = {}
				var orgao = _.find(this.orgaos, (o) => {
					return o.id == org.id
				})
				orgao_apoiado.erroOrgao = ''
				orgao_apoiado.erroTempoVoo = ''
				orgao_apoiado.orgao = orgao
				orgao_apoiado.tempo_voo = Number(org.tempo_voo).toFixed(2)
				var unidades = []

				_.forEach(org.unidade, (unidade) => {
					var uni = _.find(orgao_apoiado.orgao.unidade, (o) => {
						return o.id == unidade.id_orgao_apoiado_unidade
					})
					uni.erroUnidade = ''
					unidades.push({unidade: uni, erroUnidade: ''})
				})

				orgao_apoiado.unidade = unidades
				this.form.orgao.push(orgao_apoiado)
			})

			this.form.observacao = data.observacao

			this.form.coracao = Number(data.coracao)
			this.form.rim = Number(data.rim)
			this.form.figado = Number(data.figado)
			this.form.cornea = Number(data.cornea)
			this.form.esclero = Number(data.esclero)
			this.form.baco = Number(data.baco)

			this.form.socorrido = Number(data.socorrido)
			this.form.bambi = Number(data.bambi)
			this.form.brigadista = Number(data.brigadista)
			this.form.natureza_voo = data.natureza_voo

			

			this.form.carga = data.carga == '0' ? 'N' : 'S'
			this.form.carga_liquida = data.carga_liquida == '0' ? 'N' : 'S'
			this.form.descricao_carga = data.descricao_carga
			this.form.peso_carga = data.peso

			console.log(data.unidade_conservacao)

			// se for um array
			if (_.isArray(data.unidade_conservacao)) {
				// se existir unidade de conservação
				if (data.unidade_conservacao.length > 0) {
					this.form.unidade_conservacao = data.unidade_conservacao.map((item) => {
						return {
							obj: _.find(this.unidadesConservacao, (o) => {
								return item.id_unidade_conservacao == o.id
							}),
							erro: ''
						}
					})

					console.log(this.form.unidade_conservacao)
				}
			} else {
				// antes era uma string
				if (data.unidade_conservacao != '') {
					this.form.unidade_conservacao.push({
						obj: _.find(this.basesOperacao, (o) => {
							o.sigla == data.unidade_conservacao
						})
					})
				}
			}

			this.form.base_origem = data.base_origem

			this.calculaTempoDeVooPiloto()
			this.calculaTempoManutencao()

			if (this.visualizar) {
				this.$nextTick(() => {
					this.$refs.printVisualizar.carregaDados({
						data: this.form,
						aero: this.aeronave,
						pilotos: this._pilotos_mecanicos,
						trecho: this.trecho
					})
				})
			}
		},

		toNumber1Casa(val) {
			return Number(Number(val).toFixed(1))
		},

		toNumber2Casa(val) {
			return Number(Number(val).toFixed(2))
		},

		validaDisabledSalvar() {
			if (this.form.acionamento == '') {
				return true
			}

			if (this.form.corte == '') {
				return true
			}

			let total = this._somaTempos(this.form.hora_vfr_diurno, this.form.hora_vfr_noturno)

			if (total != this.tempoVooPiloto) {
				this.erro.diurnoNortuno = "A soma dos campos 'Diurno' e 'Noturno' deve ser igual ao 'Tempo de Voo do Piloto'."
				return true
			} else {
				this.erro.diurnoNortuno = ''
			}

			return false
		},

		blurCarregaCidades(tipo, reseta) {
			if (tipo == 'de') {
				if (this.form.nome_estado_de != '') {
					if (reseta) {
						this.form.nome_cidade_de = ''
					}

					var estado = _.find(this.estados, (o) => {
						return o.sigla.toUpperCase() == this.form.nome_estado_de.toUpperCase()
					})
					this.loadDe = true
					this.carregaCidades((callback) => {
						this.loadDe = false
						this.cidadesDe = callback.lista
						// this.cidadesDe.push({ id: '', descricao: 'ESCOLHA' })
					}, estado.id)
				}
			}

			if (tipo == 'para') {
				if (this.form.nome_estado_para != '') {
					if (reseta) {
						this.form.nome_cidade_para = ''
					}

					var estado = _.find(this.estados, (o) => {
						return o.sigla.toUpperCase() == this.form.nome_estado_para.toUpperCase()
					})
					this.loadPara = true
					this.carregaCidades((callback) => {
						this.loadPara = false
						this.cidadesPara = callback.lista
						//this.cidadesPara.push({ id: '', descricao: 'ESCOLHA' })
					}, estado.id)
				}
			}
		},

		clickExibeModalSalvar() {
			let tempo_piloto = this.tempoVooPiloto + ':00'

			if (this.validaForm() == true) {
				if (!this.editar) {
					// se o piloto for quem estiver preenchendo o diário, pede pra assinar
					if (this.form.tripulacao[0].id_usuario == $sessao.getId()) {
						this.assinar = true
					}
				} else {
					//caso for edicao valida se teve alteracoes nos horimetros e exibe mensagem no modal

					if (this.form.tempo_motor_diario != this.form.tempo_voo_motor || this.form.tempo_piloto_diario != tempo_piloto) {
						this.form.processa_horimetro = true
					}
				}

				this.revisar = false
				this.cienteAssinatura = false
				this.$refs.modalConfirmacao.modalShow(50)
				//this._exibeModal('modal-ordem-confirma-salvar', 50)
			} else {
				bus.$emit('exibir-notificacao', {type: 'danger', text: 'Corrija os campos em vermelho.'})
			}
		},

		clickSalvar() {
			if (this.validaForm()) {
				var id_usuario_piloto = 0

				if (
					this.form.horimetro_inicial == '' ||
					this.form.horimetro_inicial == 0 ||
					_.isNil(this.form.horimetro_inicial) ||
					_.isNaN(this.form.horimetro_inicial)
				) {
					return false
					bus.$emit('exibir-notificacao', {text: 'Horimetro inicial zerado', type: 'danger'})
				}

				if (
					this.form.horimetro_final == '' ||
					this.form.horimetro_final == 0 ||
					_.isNil(this.form.horimetro_final) ||
					_.isNaN(this.form.horimetro_final)
				) {
					return false
					bus.$emit('exibir-notificacao', {text: 'Horimetro final zerado', type: 'danger'})
				}

				console.log('subclassificacao', this.form.subclassificacao)
				this.formPost = {
					id_usuario: $sessao.getId(),
					id_aeronave: this.aeronave.id,
					//tempo_voo_celula: this.form.tempo_voo_celula,
					voo_instrucao: this.form.voo_instrucao,
					tempo_voo_motor: this.form.tempo_voo_motor,
					horimetro_inicial: this.form.horimetro_inicial,
					horimetro_final: this.form.horimetro_final,
					decolagem: this._dateTimeToDateSQL(this.form.decolagem, $sessao.getDateFormat() + ' HH:MM'),
					pouso: this._dateTimeToDateSQL(this.form.pouso, $sessao.getDateFormat() + ' HH:MM'),
					id: this.trecho.id,
					tipo_voo: this.form.tipo_voo,
					acionamento: this._dateTimeToDateSQL(this.form.acionamento, $sessao.getDateFormat() + ' HH:MM'),
					corte: this._dateTimeToDateSQL(this.form.corte, $sessao.getDateFormat() + ' HH:MM'),
					acionamento_utc: this._dateTimeToDateSQL(this.form.acionamento_utc, $sessao.getDateFormat() + ' HH:MM'),
					decolagem_utc: this._dateTimeToDateSQL(this.form.decolagem_utc, $sessao.getDateFormat() + ' HH:MM'),
					pouso_utc: this._dateTimeToDateSQL(this.form.pouso_utc, $sessao.getDateFormat() + ' HH:MM'),
					corte_utc: this._dateTimeToDateSQL(this.form.corte_utc, $sessao.getDateFormat() + ' HH:MM'),

					id_aeronave_import: this.aeronave_import != '' ? this.aeronave_import.id_aeronave : null,

					ultima_intervencao: this.form.ultima_intervencao,
					proxima_intervencao: this.form.proxima_intervencao,
					horimetro_proxima: this.form.horimetro_proxima,
					id_responsavel_retorno: this.form.id_responsavel_retorno,
					nome_usuario_retorno: this.form.nome_usuario_retorno,
					descricao_ultima_inspecao: this.form.descricao_ultima_inspecao,
					descricao_proxima_inspecao: this.form.descricao_proxima_inspecao,

					objetivo_alcancado: this.form.objetivo_alcancado,
					tipo_voo_pagamento: this.form.tipo_voo_pagamento,
					adiciona_horimetro_manutencao: this.form.adiciona_horimetro_manutencao,
					tempo_voo_manutencao: this.form.tempo_voo_manutencao,
					horimetro_manutencao: this.form.horimetro_manutencao,
					horimetro_final_manutencao: this.form.horimetro_manutencao_final,

					aeronave: {
						id_aeronave: this.aeronave.id,
						horimetro_manutencao: this.form.horimetro_manutencao
					},

					finalizar_ordem: this.form.finalizar_ordem,
					finalizar_despacho: this.form.finalizar_despacho,
					id_despacho: this.despacho != '' ? this.despacho.id : null,

					de: this.form.de,
					nome_estado_de: this.form.nome_estado_de,
					nome_cidade_de: this.form.nome_cidade_de,
					unidade_combustivel: this.form.unidade_combustivel,

					gancho: this.form.gancho,
					guincho: this.form.guincho,

					base: this.form.base,

					para: this.form.para,
					nome_estado_para: this.form.nome_estado_para,
					nome_cidade_para: this.form.nome_cidade_para,

					vfr_diurno: this.form.vfr_diurno,
					hora_vfr_diurno: this.form.hora_vfr_diurno,
					vfr_noturno: this.form.vfr_noturno,
					hora_vfr_noturno: this.form.hora_vfr_noturno,
					ifr: this.form.ifr,
					hora_ifr: this.form.hora_ifr,
					navegacao: this.form.navegacao,
					hora_navegacao: this.form.hora_navegacao,
					// instrucao: this.form.instrucao,
					total: this.form.total,

					ciclo_ng: this.form.ciclo_ng,
					ciclo_nf: this.form.ciclo_nf,
					numero_voo: this.form.numero_voo,

					combustivel: this.form.combustivel,
					partidas: this.form.partidas,
					pousos: this.form.pousos,

					id_tipo_missao: this.form.tipo_missao.id,
					tipo_classificacao: this.form.tipo_classificacao,

					observacao: this.form.observacao,

					// missao_inicio: this._dateTimeToDateSQL(this.form.missao_inicio, $sessao.getDateFormat() + ' HH:MM'),
					// missao_fim: this._dateTimeToDateSQL(this.form.missao_fim, $sessao.getDateFormat() + ' HH:MM'),
					natureza_voo: this.form.natureza_voo,

					// descricao: this.form.descricao,

					id_classificacao: this.form.classificacao.id,
					id_subclassificacao:
						this.form.subclassificacao == '' || this.form.subclassificacao == null
							? (this.form.subclassificacao = null)
							: this.form.subclassificacao.id,
					// id_subclassificacao_divisao: this.form.divisao == '' ? this.form.divisao = null : this.form.divisao.id,

					// unidade_conservacao: this.form.unidade_conservacao.map(item => {
					// 	return { id: _.isNil(item.obj.id) ? 0 :item.obj.id }
					// }),
					unidade_conservacao: [],
					base_origem: this.form.base_origem,

					coracao: this.form.coracao,
					rim: this.form.rim,
					figado: this.form.figado,
					cornea: this.form.cornea,
					esclero: this.form.esclero,
					baco: this.form.baco,

					carga: this.form.carga == 'S' ? true : false,
					descricao_carga: this.form.descricao_carga,
					carga_liquida: this.form.carga_liquida == 'S' ? true : false,
					peso: this.form.peso_carga,

					socorrido: this.form.socorrido,
					existe_unidade_conservacao: this.form.existe_unidade_conservacao,
					bambi: this.form.bambi,
					brigadista: this.form.brigadista,

					auto_localizado: this.form.auto_localizado,
					arma_apreendida: this.form.arma_apreendida,
					pessoa_salva: this.form.pessoa_salva,
					pessoa_detida: this.form.pessoa_detida,
					valor_recuperado: this.form.valor_recuperado,

					houve_contexto: this.form.houve_contexto,
					contexto_operativo: this.form.contexto_operativo == '' ? '' : this.form.contexto_operativo.id,

					numero_atividade: this.form.numero_atividade,
					numero_bo: this.form.numero_bo,
					diario_fisico: this.form.diario_fisico,
					numero_chamado: this.form.numero_chamada,

					ovn: this.form.ovn,
					flir: this.form.flir,
					processa_horimetro: this.form.processa_horimetro,

					tripulacao: this.form.tripulacao.map((item) => {
						var trip = {
							id_usuario: item.id_usuario,
							apresentacao:
								item.apresentacao != '' ? this._dateTimeToDateSQL(item.apresentacao, $sessao.getDateFormat() + ' HH:MM') : '',
							codigo_ovn: item.codigo_ovn,
							anac: item.anac,
							funcao: item.funcao,
							nome: item.nome,
							trigrama: item.trigrama
						}

						if (item.funcao.toUpperCase() == 'PILOTO EM COMANDO') {
							id_usuario_piloto = item.id_usuario
						}

						return trip
					}),

					discrepancia: this.form.discrepancia.map((item) => {
						return {
							id: item.id,
							id_usuario: item.id_usuario,
							descricao: item.descricao,
							anac: item.anac,
							tipo: item.tipo
						}
					}),

					passageiro: this.form.passageiro.map((item) => {
						var pass = {
							tipo: item.tipo,
							nome: item.nome,
							orgao: item.orgao,
							cargo: item.cargo,
							cpf: item.cpf,
							telefone: item.telefone,
							data_nascimento: this._dateToDateSQL(item.data_nascimento, $sessao.getDateFormat()),
							idade_aparente: item.idade_aparente,
							sexo: item.sexo
						}
						return pass
					}),

					ocorrencias: this.form.ocorrencias.map((item) => {
						return {
							id: item.id,
							data: item.data != '' ? this._dateTimeToDateSQL(item.data, $sessao.getDateFormat() + ' HH:MM') : '',
							local: item.local,
							codigo_classificacao: item.codigo_classificacao,
							qualificacao_civil: item.qualificacao_civil,
							descricao_fatos: item.descricao_fatos
						}
					}),

					ocorrencia: this.form.ocorrencias.length > 0 ? '1' : '0',
					orgao: this.form.orgao.map((item) => {
						var org = {
							id: item.orgao.id,
							tempo_voo: item.tempo_voo,
							unidade: []
						}

						if (item.unidade.length > 0) {
							org.unidade = item.unidade.map((it) => {
								return {id: it.unidade.id}
							})
						}

						return org
					})
				}

				bus.$emit('load-in', {text: this._traducao('global', 'salvando')})

				this.formPost.id_usuario_piloto = id_usuario_piloto

				// se não for meio ambiente, limpa as unidades
				if (this.formPost.id_tipo_missao != 3) {
					this.formPost.unidade_conservacao = []
				} else {
					// se for meio ambiente, verifica se existe unidades
					if (this.formPost.existe_unidade_conservacao == '0') {
						this.formPost.unidade_conservacao = []
					}
				}

				console.log('ESTOU LHE ENVIANDO', this.formPost)
				this._httpPost('cta-maranhao/Relatorio_voo_trecho/salvar', this.formPost, (response) => {
					console.log('ESTOU RECEBENDO', response)
					bus.$emit('load-out')

					if (response._request) {
						// ao fechar o modal roda a função modalCarregaAssinatura()
						this.$refs.modalConfirmacao.modalHide()
						this.limpaTimeOuts()
					}
				})
			}
		},

		modalCarregaAssinatura() {
			if (!this.revisar) {
				if (this.assinar) {
					var obj = {
						id_usuario: $sessao.getId(),
						id_aeronave: this.aeronave.id,
						tempo_voo_celula: this.form.tempo_voo_celula,
						tempo_voo_motor: this.form.tempo_voo_motor,
						horimetro_inicial: this.form.horimetro_inicial,
						horimetro_final: this.form.horimetro_final,
						decolagem: this.form.decolagem,
						pouso: this.form.pouso,
						id: this.trecho.id,
						tipo_voo: this.form.tipo_voo,
						acionamento: this.form.acionamento,
						corte: this.form.corte
						//nome_pdf: this.aeronave.prefixo +'-'+ this.trecho.numero_diario + '.pdf'
					}

					// chama o component de assinatura
					this.$refs.assinatura.carregaAssinatura(obj)
				} else {
					bus.$emit('exibir-notificacao', {type: 'success', text: this._traducao('global', 'salvo')})
					//
					this.voltaLista()
				}
			}
		},

		// retorno da assinatura
		validaAssinatura(retorno) {
			bus.$emit('load-in', {text: this._traducao('global', 'assinando')})

			var data = {
				id_assinatura: retorno.assinatura.id,
				id_usuario: $sessao.getId(),
				id_relatorio_voo_trecho: retorno.data.id
			}

			//bus.$emit('load-in', {text: this._traducao('global', 'assinando')})

			// salva a assinatura
			this._httpPost('cta-maranhao/Relatorio_voo_trecho/assinatura_piloto', data, (response) => {
				bus.$emit('load-out')
				if (response._request) {
					this.voltaLista()
					bus.$emit('exibir-notificacao', {type: 'success', text: this._traducao('global', 'trechoAssinado')})
					bus.$off('modal-fechou')
				}
			})
		},

		calculaTempoDeVooPiloto() {
			if (this.form.acionamento != '' && this.form.corte != '') {
				this.form.tempo_voo_piloto = this._timeToDecimal(this.form.acionamento, this.form.corte)
			}
		},

		calculaTempoManutencao() {
			if (this.form.decolagem != '' && this.form.pouso != '') {
				this.form.tempo_voo_motor = this._timeToDecimal(this.form.decolagem, this.form.pouso)
				this.$nextTick(() => {
					this.form.horimetro_manutencao_final = Number(this.form.horimetro_manutencao) + Number(this.form.tempo_voo_motor)
					if (this.form.adiciona_horimetro_manutencao == '1') {
						this.alteraHorimetroManutencao('+')
					}
					if (this.form.adiciona_horimetro_manutencao == '0') {
						this.alteraHorimetroManutencao('-')
					}
					this.$forceUpdate()
				})
			}
		},

		calculaTotal() {
			if (this.aeronave.tipo == 'H') {
				this.form.horimetro_final = this.form.horimetro_inicial + Number(this.form.tempo_voo_piloto)
			} else {
				this.form.horimetro_final = this.form.horimetro_inicial + Number(this.form.tempo_voo_motor)
			}
		},

		validaForm() {
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')
			var obrig = this._traducao('global', 'obrigacao')

			

			// valida o corte e o acionamento do motor
			if (this.form.acionamento == '') {
				this.erro.acionamento = obrig
				passou = false
			} else {
				this.erro.acionamento = ''
			}

			// decolagem
			if (this.form.tipo_voo_pagamento == 'S' || this.form.pouso != '') {
				if (this.form.decolagem == '') {
					this.erro.decolagem = obrig
					passou = false
				} else {
					this.erro.decolagem = ''
				}
			}

			// pouso
			if (this.form.tipo_voo_pagamento == 'S' || this.form.decolagem != '') {
				if (this.form.pouso == '') {
					this.erro.pouso = obrig
					passou = false
				} else {
					this.erro.pouso = ''
				}
			}

			//corte
			if (this.form.corte == '') {
				this.erro.corte = obrig
				passou = false
			} else {
				this.erro.corte = ''
			}

			if (this.erro.ifr != '') {
				passou = false
			}

			if (this.erro.navegacao != '') {
				passou = false
			}

			// quer dizer q todos campos tao preenchindos
			if (passou) {
				var dtAcionamento = new moment(this._dateTimeToDateSQL(this.form.acionamento, $sessao.getDateFormat() + ' HH:MM'))
				var dtDecolagem = new moment(this._dateTimeToDateSQL(this.form.decolagem, $sessao.getDateFormat() + ' HH:MM'))
				var dtPouso = new moment(this._dateTimeToDateSQL(this.form.pouso, $sessao.getDateFormat() + ' HH:MM'))
				var dtCorte = new moment(this._dateTimeToDateSQL(this.form.corte, $sessao.getDateFormat() + ' HH:MM'))

				if (moment(dtAcionamento).isAfter(dtDecolagem)) {
					this.erro.decolagem = 'Decolagem menor que acionamento.'
					passou = false
				} else {
					this.erro.decolagem = ''
				}

				if (moment(dtDecolagem).isAfter(dtPouso)) {
					this.erro.pouso = 'Pouso menor que decolagem.'
					passou = false
				} else {
					this.erro.pouso = ''
				}

				if (moment(dtPouso).isAfter(dtCorte)) {
					this.erro.corte = 'Corte menor que pouso.'
					passou = false
				} else {
					this.erro.corte = ''
				}
			}

			if (this.form.tempo_voo_motor > 8) {
				this.erro.tempo_voo_motor = 'Tempo de voo muito grande'
				passou = false
			} else {
				this.erro.tempo_voo_motor = ''
			}

			if (this.form.tempo_voo_piloto > 8) {
				this.erro.tempo_voo_piloto = 'Tempo de voo muito grande'
				passou = false
			} else {
				this.erro.tempo_voo_piloto = ''
			}

			// valida base
			if (this.form.base == '') {
				passou = false
				this.erro.base = obrigatorio
			} else {
				this.erro.base = ''
			}

			// combustivel
			if (this.form.combustivel == 0) {
				this.erro.combustivel = obrig
				passou = false
			} else {
				this.erro.combustivel = ''
			}

			// unidade de combustivel
			if (this.form.unidade_combustivel == '') {
				this.erro.unidade_combustivel = obrig
				passou = false
			} else {
				this.erro.unidade_combustivel = ''
			}

			// de
			if (this.form.de == '') {
				this.erro.de = obrig
				passou = false
			} else {
				this.erro.de = ''
			}

			// para
			if (this.form.para == '') {
				this.erro.para = obrig
				passou = false
			} else {
				this.erro.para = ''
			}

			if (this.form.horimetro_inicial == 0) {
				this.erro.horimetro_inicial = obrigatorio
				passou = false
			} else {
				this.erro.horimetro_inicial = ''
			}

			// nome_cidade_de
			if (this.form.nome_cidade_de == '') {
				this.erro.nome_cidade_de = obrig
				passou = false
			} else {
				this.erro.nome_cidade_de = ''
			}

			// nome_cidade_para
			if (this.form.nome_cidade_para == '') {
				this.erro.nome_cidade_para = obrig
				passou = false
			} else {
				this.erro.nome_cidade_para = ''
			}

			// nome_estado_de
			if (this.form.nome_estado_de == '') {
				this.erro.nome_estado_de = obrig
				passou = false
			} else {
				this.erro.nome_estado_de = ''
			}

			// nome_estado_para
			if (this.form.nome_estado_para == '') {
				this.erro.nome_estado_para = obrig
				passou = false
			} else {
				this.erro.nome_estado_para = ''
			}

			// valida flir
			// if(this.aeronave.tipo == 'H'){
			//     if (this.form.flir == "") {
			//         this.erro.flir = obrig
			//         passou = false
			//     } else {
			//         this.erro.flir = ""
			//     }
			// }

			// valida ovn
			// if(this.aeronave.tipo == 'H'){
			//     if (this.form.ovn == "") {
			//         this.erro.ovn = obrig
			//         passou = false
			//     } else {
			//         this.erro.ovn = ""
			//     }
			// }

			// b3 // VMD
			if (this.aeronave.ciclo_total == '1') {
				// if(this.form.tipo_voo_pagamento == 'S'){
				// 	if(this.form.ciclo_ng == ''){
				// 		this.erro.ciclo_ng = obrig
				// 		passou = false
				// 	} else {
				// 		this.erro.ciclo_ng = ''
				// 	}

				// 	if(this.form.ciclo_nf == ''){
				// 		this.erro.ciclo_nf = obrig
				// 		passou = false
				// 	} else {
				// 		this.erro.ciclo_nf = ''
				// 	}
				// }

				if (this.form.numero_voo == '') {
					this.erro.numero_voo = obrig
					passou = false
				} else {
					this.erro.numero_voo = ''
				}
			}

			// PILOTO
			if (this.form.tripulacao[0].id_usuario == '') {
				this.form.tripulacao[0].erroUsuario = obrigatorio
				passou = false
			} else {
				this.form.tripulacao[0].erroUsuario = ''
			}
			// valida apresentacao do piloto
			if (this.form.tripulacao[0].apresentacao == '') {
				this.form.tripulacao[0].erroApresentacao = obrigatorio
				passou = false
			} else {
				this.form.tripulacao[0].erroApresentacao = ''

				var dtAcionamento = new moment(this._dateTimeToDateSQL(this.form.acionamento, $sessao.getDateFormat() + ' HH:MM'))
				var apresentacao = new moment(
					this._dateTimeToDateSQL(this.form.tripulacao[0].apresentacao, $sessao.getDateFormat() + ' HH:MM')
				)

				if (moment(apresentacao).isAfter(dtAcionamento)) {
					this.form.tripulacao[0].erroApresentacao = 'Maior que o acionamento.'
					passou = false
				} else {
					this.form.tripulacao[0].erroApresentacao = ''
				}
			}

			// valida o codigo ovn do piloto
			// if(this.aeronave.tipo == 'H'){
			//     if (this.form.ovn == '1') {
			//         if (this.form.tripulacao[0].codigo_ovn == "") {
			//             this.form.tripulacao[0].erroOVN = obrigatorio
			//             passou = false
			//         } else {
			//             this.form.tripulacao[0].erroOVN = ""
			//         }
			//     }
			// }

			// se tiver mais de 2 tripulantes, quer dizer q tem trip op, valida os campos
			if (this.form.tripulacao.length > 1) {
				for (var i = 1; i < this.form.tripulacao.length; i++) {
					if (this.form.tripulacao[i].funcao == '') {
						this.form.tripulacao[i].erroFuncao = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroFuncao = ''
					}

					// valida o nome
					if (this.form.tripulacao[i].id_usuario == '') {
						this.form.tripulacao[i].erroUsuario = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroUsuario = ''

						var pass = true
						_.forEach(this.form.tripulacao, (value, key) => {
							if (key != i) {
								if (value.id_usuario == this.form.tripulacao[i].id_usuario) {
									pass = false
								}
							}
						})

						if (!pass) {
							this.form.tripulacao[i].erroUsuario = 'Tripulante repetido.'
							passou = false
						} else {
							this.form.tripulacao[i].erroUsuario = ''
						}
					}

					if (
						this.form.ovn == '1' &&
						this.aeronave.tipo == 'H' &&
						(this.form.tripulacao[i].funcao == 'Piloto em Comando' ||
							this.form.tripulacao[i].funcao == 'Operador Aerotático' ||
							this.form.tripulacao[i].funcao == 'Copiloto')
					) {
						if (this.form.tripulacao[i].codigo_ovn == '') {
							this.form.tripulacao[i].erroOVN = obrigatorio
							passou = false
						} else {
							this.form.tripulacao[i].erroOVN = ''
						}
					}

					// valida a apresentacao
					if (this.form.tripulacao[i].apresentacao == '') {
						this.form.tripulacao[i].erroApresentacao = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroApresentacao = ''
						var dtAcionamento = new moment(this._dateTimeToDateSQL(this.form.acionamento, $sessao.getDateFormat() + ' HH:MM'))
						var apresentacao = new moment(
							this._dateTimeToDateSQL(this.form.tripulacao[i].apresentacao, $sessao.getDateFormat() + ' HH:MM')
						)

						if (moment(apresentacao).isAfter(dtAcionamento)) {
							this.form.tripulacao[i].erroApresentacao = 'Maior que o acionamento.'
							passou = false
						} else {
							this.form.tripulacao[i].erroApresentacao = ''
						}
					}
				}
			}

			if (this.form.tipo_missao) {
				if (this.form.existe_unidade_conservacao == '' && this.form.tipo_missao.descricao == 'MEIO AMBIENTE') {
					this.erro.existe_unidade_conservacao = 'Obrigatório.'
					passou = false
				} else {
					this.erro.existe_unidade_conservacao = ''
				}

				// obriga a inserir unidades de conservação
				if (this.form.existe_unidade_conservacao == '1' && this.form.tipo_missao.descricao == 'MEIO AMBIENTE') {
					this.form.unidade_conservacao = this.form.unidade_conservacao.map((item) => {
						if (item.obj == '') {
							item.erro = 'Campo obrigatório.'
							passou = false
						} else {
							item.erro = ''
						}
						return item
					})
				}
			}
			if (this.form.tipo_missao.id == '4') {
				if (this.form.tipo_classificacao == '' || this.form.tipo_classificacao == null) {
					this.erro.tipo_classificacao = 'Obrigatório.'
					passou = false
				} else {
					this.erro.tipo_classificacao = ''
				}
			}

			if (this.form.diario_fisico == '') {
				this.erro.diario_fisico = 'Obrigatório.'
				passou = false
			} else {
				this.erro.diario_fisico = ''
			}

			// se for um voo de instrucao
			if (this.form.voo_instrucao == '1') {
				
				var pilotoInstrucao = _.find(this.form.tripulacao, function (o) {
					return o.funcao == 'Piloto em Instrução'
				})

				if (_.isNil(pilotoInstrucao)) {
					passou = false
					this.erro.instrutor_voo = "Voo de instrução deve conter um 'Piloto em Instrução'."
				} else {
					this.erro.instrutor_voo = ''
				}
			}

			// valida os passageiros
			if (this.form.passageiro.length > 0) {
				for (var i in this.form.passageiro) {
					if (this.form.passageiro[i].tipo == 'V') {
						// valida nome
						if (this.form.passageiro[i].nome == '') {
							this.form.passageiro[i].nomeErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].nomeErro = ''
						}

						//valida sexo
						if (this.form.passageiro[i].sexo == '') {
							this.form.passageiro[i].sexoErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].sexoErro = ''
						}

						//valida idade
						if (this.form.passageiro[i].idade == '') {
							this.form.passageiro[i].idadeErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].idadeErro = ''
						}
					}

					if (this.form.passageiro[i].tipo == 'P') {
						// valida nome
						if (this.form.passageiro[i].nome == '') {
							this.form.passageiro[i].nomeErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].nomeErro = ''
						}

						// valida orgao
						if (this.form.passageiro[i].orgao == '') {
							this.form.passageiro[i].orgaoErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].orgaoErro = ''
						}

						// valida cargo
						if (this.form.passageiro[i].cargo == '') {
							this.form.passageiro[i].cargoErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].cargoErro = ''
						}
					}
				}
			}

			// VALIDA CARGA
			if (this.form.carga == '') {
				this.erro.carga = obrig
				passou = false
			} else {
				this.erro.carga = ''

				// VALIDA CASO TENHA CARGA
				if (this.form.carga == 'S') {
					if (this.form.descricao_carga == '') {
						this.erro.descricao_carga = obrig
						passou = false
					} else {
						this.erro.descricao_carga = ''
					}

					if (this.form.peso_carga == '') {
						this.erro.peso_carga = obrig
						passou = false
					} else {
						this.erro.peso_carga = ''
					}

					if (this.form.carga_liquida.trim() == '') {
						this.erro.carga_liquida = obrig
						passou = false
					} else {
						this.erro.carga_liquida = ''
					}
				}
			}

			// PMSP
			if (this._idCliente == 14) {
				var soma = 0
				this.form.orgao = this.form.orgao.map((item) => {
					soma += item.tempo_voo

					return item
				})

				if (Number(this.form.tempo_voo_piloto).toFixed(1) != Number(soma).toFixed(1)) {
					passou = false
					this.form.orgao = this.form.orgao.map((item) => {
						item.erroTempoVoo = 'A soma é diferente que o tempo do piloto'
						return item
					})
				} else {
					this.form.orgao = this.form.orgao.map((item) => {
						item.erroTempoVoo = ''
						return item
					})
				}
			}

			// valida a discrepancia
			if (this.form.discrepancia.length > 0) {
				for (var i in this.form.discrepancia) {
					if (this.form.discrepancia[i].id_usuario == '') {
						this.form.discrepancia[i].erroUsuario = obrigatorio
						passou = false
					} else {
						this.form.discrepancia[i].erroUsuario = ''
					}

					if (this.form.discrepancia[i].tipo == '') {
						this.form.discrepancia[i].erroTipo = obrigatorio
						passou = false
					} else {
						this.form.discrepancia[i].erroTipo = ''
					}

					if (this.form.discrepancia[i].descricao == '') {
						this.form.discrepancia[i].erroDescricao = obrigatorio
						passou = false
					} else {
						this.form.discrepancia[i].erroDescricao = ''
					}
				}
			}

			// valida a ocorrencia
			if (this.form.ocorrencias.length > 0) {
				this.form.ocorrencias = this.form.ocorrencias.map((item) => {
					if (item.data == '') {
						item.erro_data = obrigatorio
						passou = false
					} else {
						item.erro_data = ''
					}

					if (item.local == '') {
						item.erro_local = obrigatorio
						passou = false
					} else {
						item.erro_local = ''
					}

					if (item.codigo_classificacao == '') {
						item.erro_codigo_classificacao = obrigatorio
						passou = false
					} else {
						item.erro_codigo_classificacao = ''
					}

					if (item.qualificacao_civil == '') {
						item.erro_qualificacao_civil = obrigatorio
						passou = false
					} else {
						item.erro_qualificacao_civil = ''
					}

					if (item.descricao_fatos == '') {
						item.erro_descricao_fatos = obrigatorio
						passou = false
					} else {
						item.erro_descricao_fatos = ''
					}

					return item
				})
			}

			if (this.form.numero_chamada == '') {
				this.erro.numero_chamada = obrigatorio
				passou = false
			} else {
				this.erro.numero_chamada = ''
			}

			if (this.form.objetivo_alcancado == '') {
				this.erro.objetivo_alcancado = obrigatorio
				passou = false
			} else {
				this.erro.objetivo_alcancado = ''
			}

			if (this.form.tipo_voo_pagamento == '') {
				this.erro.tipo_voo_pagamento = obrigatorio
				passou = false
			} else {
				this.erro.tipo_voo_pagamento = ''
			}

			if (this.form.tipo_voo_pagamento == 'E') {
				if (this.form.adiciona_horimetro_manutencao == '') {
					this.erro.adiciona_horimetro_manutencao = obrigatorio
					passou = false
				} else {
					this.erro.adiciona_horimetro_manutencao = ''
				}
			}

			// tipo de missao
			if (!this.form.tipo_missao) {
				this.erro.tipo_missao = obrigatorio
				passou = false
			} else {
				this.erro.tipo_missao = ''
			}

			// descricao
			// if (!this.form.descricao) {
			//     this.erro.descricao = obrigatorio
			//     passou = false
			// } else {
			//     this.erro.descricao = ""
			// }
			// classificacao
			if (this.form.classificacao == '') {
				this.erro.classificacao = obrigatorio
				passou = false
			} else {
				this.erro.classificacao = ''
			}
			// subclassificacao

			for (var i = 0; i < this.subclassificacoes.length; i++) {
				if (this.subclassificacoes[i].id_classificacao == this.form.classificacao) {
					if (this.form.subclassificacao == '') {
						this.erro.subclassificacao = obrigatorio
						passou = false
					} else {
						this.erro.subclassificacao = ''
					}
					break
				} else {
					this.erro.subclassificacao = ''
				}
			}

			// orgao
			if (this.form.orgao.length == 0) {
				this.erro.orgao = obrigatorio
				passou = false
			} else {
				this.erro.orgao = ''

				for (var i in this.form.orgao) {
					if (this.form.orgao[i].orgao == '') {
						this.form.orgao[i].erroOrgao = obrigatorio
						passou = false
					} else {
						this.form.orgao[i].erroOrgao = ''

						// se o orgao tiver unidades
						if (this.form.orgao[i].orgao.unidade.length > 0) {
							if (this.form.orgao[i].unidade.length == 0) {
								this.form.orgao[i].erroOrgao = this._traducao('global', 'voceTemQueEscolherUnidade') + ' ---->'
								passou = false
							} else {
								this.form.orgao[i].erroOrgao = ''
							}

							for (var j in this.form.orgao[i].unidade) {
								if (this.form.orgao[i].unidade[j].unidade == '') {
									this.form.orgao[i].unidade[j].erroUnidade = obrig
									passou = false
								} else {
									this.form.orgao[i].unidade[j].erroUnidade = ''
								}
							}
						}
					}
				}
			}

			// houve contexto
			if (this.form.houve_contexto == '') {
				this.erro.houve_contexto = obrigatorio
				passou = false
			} else {
				this.erro.houve_contexto = ''

				if (this.form.houve_contexto == '1') {
					if (this.form.contexto_operativo == '') {
						this.erro.contexto_operativo = obrigatorio
						passou = false
					} else {
						this.erro.contexto_operativo = ''
					}
				}
			}

			if (this.despacho != '') {
				// se tiver ordem
				if (this.despacho.id_ordem_missao != null) {
					if (this.form.finalizar_ordem == '') {
						this.erro.finalizar_ordem = obrigatorio
						passou = false
					} else {
						this.erro.finalizar_ordem = ''
					}
				}

				if (this.form.finalizar_despacho == '') {
					this.erro.finalizar_despacho = obrigatorio
					passou = false
				} else {
					this.erro.finalizar_despacho = ''
				}
			}

			return passou
		},

		// carregaDivisoes(){
		// 	this._httpGet('Subclassificacao_divisao/get/', request => {
		// 		bus.$emit('load-out')
		// 		if(request._request){
		// 			if(request._status){
		// 				this.divisoes = request.lista
		// 			}
		// 		}
		// 	})
		// },

		voltaLista() {
			this.limpaTimeOuts()
			this._escondeModal('modal-ordem-tempo-expirado')
			this.$emit('volta-diario-piloto')
			//bus.$emit('volta-diario-piloto', this.name)
		},

		limpaTimeOuts() {
			clearTimeout(this.timeOut)
			clearTimeout(this.timeOutModal)
		},

		carregaDados() {
			// ROTA AE
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this._providerRotaer((lista) => {
				bus.$emit('load-out')
				this.rotaER = lista
				this.rotaER.push({sigla: 'ZZZZ'})
			})

			// AERONAVE
			this.loadAero = true
			this._providerAeronave((lista) => {
				this.loadAero = false
				this.aeronaves = lista
			})
			// ESTADOS
			this._providerEstado((lista) => {
				this.estados = lista
			})
			// CLASSIFICACAO
			this._providerClassificacao((lista) => {
				this.classificacoes = lista
			})

			// SUBCLASSIFICACAO
			this._providerSubclassificacao((lista) => {
				this.subclassificacoes = lista
			})

			// UNIDADE CONSERVACAO
			this._providerUnidadeConservacao((lista) => {
				this.unidadesConservacao = lista
			})

			// carrega pilotos
			this._httpGet('Usuario/get_by_perfil/' + 14, (retorno) => {
				if (retorno._request) {
					this.pilotos = retorno.lista
				}
			})

			// mecanicos
			this._httpGet('Usuario/get_by_perfil/' + 16, (retorno) => {
				if (retorno._request) {
					this.mecanicos = retorno.lista
				}
			})

			this._providerContextoOperativo((lista) => {
				this.contextos = lista
			})

			this._providerOrgaoApoiado((lista) => {
				this.orgaos = lista
			})

			this._providerBaseOperacional((lista) => (this.bases = lista))
			this._providerDescricaoDaMissao((lista) => (this.descricoes = lista))
			this._providerTipoDeMissao((lista) => (this.tiposDeMissoes = lista))
			// this.carregaDivisoes()
		}
	}
}
</script>

<style scoped>
.table-hover-tr:hover td {
	background: #f0f0f0;
}

.bk-success td {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}
</style>